<template>
  <a-modal
    :width="1080"
    v-model="vable"
    @ok="flashOk"
    :footer="null"
    :loading="loading"
    :maskClosable="false"
    @cancel="handleCancel()"
  >
    <span slot="title">
      <span v-if="study === '1' && period === '3'">
        当前教材：高中英语 > {{ press }} > {{ required | studyFolter }} > {{ name }}
      </span>
      <span v-else-if="study === '2' && period === '3'">
        当前教材：高中英语 > {{ press }} > {{ elective | studyFolter2 }} > {{ name }}
      </span>
      <span v-else-if="grade <= '6' && grade !=''">
        当前教材：小学英语 > {{ press }} > {{ grade | gradeFolter }}{{ volume | volumeFolter }} > {{ name }}
      </span>
      <span v-else-if="flashType =='1' ">
        词语速记作业 : {{ homeworkName }}
      </span>
      <span v-else-if="flashType =='2' ">
        错词本：
      </span>
      <span v-else>
        当前教材：初中英语 > {{ press }} > {{ grade | gradeFolter }}{{ volume | volumeFolter }} > {{ name }}
      </span>
    </span>
    <div
      style="width: 100%;height: 710px;"
      class="ciyusujibukefuzhi"
    >
      <a-spin
        :indicator="indicator"
        :spinning="spinning"
      >
        <a-col
          v-if="!resultView"
          :span="24"
          style="background:linear-gradient(#079CDE,white);height:700px; border-radius:5px;"
        >

          <!-- 画面一览界面 -->
          <div
            class="editorciyusuji"
            v-if="start"
          >
            <div align="center">
              <img
                alt="example"
                style="margin:120px 0px 10px 0;height:130px;"
                src="/abc_logo.png"
                slot="cover"
              />
              <div style="display:block;font-size:2em;margin-block-start:0.67em;margin-block-end: 0.67em;marginBottom:40px">
                目标词汇量：共 {{ total }} 词
              </div>
              <h1>
                <a-button
                  :disabled="this.total == 0"
                  size="large"
                  style="font-size:25px;color:white;font-family:Arial,Helvetica,sans-serif;width:240px;background-color:#FF6C00;height:53px;border-radius:15px 15px 15px 15px;"
                  @click="learn"
                >开始学习</a-button>
              </h1>
              <h1>
                <a-button
                  v-if="flashType === '0'"
                  :disabled="isDisable || this.total == 0"
                  size="large"
                  style="font-size:25px;color:white;font-family:Arial,Helvetica,sans-serif;width:240px;background-color:#FF6C00;height:53px;border-radius:15px 15px 15px 15px;"
                  @click="challengeAll"
                >开始挑战</a-button>
                <a-button
                  v-if="flashType === '1'"
                  :disabled="isDisable || this.total == 0"
                  size="large"
                  style="font-size:25px;color:white;font-family:Arial,Helvetica,sans-serif;width:240px;background-color:#FF6C00;height:53px;border-radius:15px 15px 15px 15px;"
                  @click="challengeAll"
                >去做作业</a-button>
                <a-button
                  v-if="flashType === '2'"
                  :disabled="isDisable || this.total == 0"
                  size="large"
                  style="font-size:25px;color:white;font-family:Arial,Helvetica,sans-serif;width:240px;background-color:#FF6C00;height:53px;border-radius:15px 15px 15px 15px;"
                  @click="challengeAll"
                >开始复习</a-button>
              </h1>
            </div>
          </div>

          <!-- 开始学习单词列表界面 -->
          <div
            class="editorciyusuji"
            v-if="startLearn"
          >
            <div style="margin:10px 20px">
              <a-row :gutter="16">
                <a-col
                  :span="19"
                  :offset="1"
                  style="line-height:40px;"
                >
                  <a-progress
                    :percent="percents"
                    :showInfo="false"
                    :strokeWidth="20"
                    strokeColor="#ff5500"
                  />
                </a-col>
                <a-col :span="4">
                  <a-button
                    disabled
                    size="large"
                    style="border-radius:50px;border:2px solid #ff5500;font-size:22px;font-weigth:bold;color:#000;"
                  >{{ percent }}/{{ total }}</a-button>
                </a-col>
              </a-row>
              <!-- 后退按钮 -->
              <a-button
                size="large"
                shape="circle"
                v-if="percent > 1"
                icon="left"
                @click="decline"
                style="background-color: #fafafa;float:left;marginTop:198px;height:70px;width:70px;marginLeft:15px"
              />
              <!-- 前进按钮 -->
              <a-button
                size="large"
                shape="circle"
                v-if="percent < total"
                icon="right"
                @click="increase"
                style="background-color: #fafafa;float:right;marginTop:198px;height:70px;width:70px;marginRight:15px"
              />
              <div class="steps-content">
                <div align="center">

                  <div style="display:block;font-size:50px;margin-block-start:0.67em;margin-block-end: 0.67em;marginBottom:20px;paddingLeft:31px">
                    {{ wordList[percent-1].word }}
                    <span>
                      <a
                        :title="playFlag?'暂停':'播放'"
                        href="javascript:;"
                        @click="startPlayOrPauseUSA"
                      >
                        <a-icon
                          type="sound"
                          style="fontSize:40px;padding:17px 0px 0px 30px;"
                        />
                      </a>
                      <audio
                        v-if="wordList[percent-1].americanSound !==null && wordList[percent-1].americanSound !==''"
                        ref="audioUSA"
                        :src="wordList[percent-1].americanSound"
                        @play="onPlay"
                        controls
                        hidden="true"
                        autoplay="autoplay"
                        @pause="onPause"
                        @error="onError(percent)"
                        @timeupdate="onTimeupdate"
                      >
                      </audio>
                      <audio
                        v-else
                        ref="audioUSA"
                        src=""
                        @play="onPlay"
                        @pause="onPause"
                        @error="onError"
                        @timeupdate="onTimeupdate"
                      >
                      </audio>
                    </span>
                  </div>
                  <!-- 下划线 -->
                  <hr style="height:5px;border:none;border-top:5px solid  green;" />

                  <a-row :gutter="16">
                    <a-col
                      :span="1"
                      style="padding:17px 0px 65px 30px;"
                    >
                      <div style="height:20px"></div>
                    </a-col>
                    <a-col :span="23">
                      <span
                        style="font-size:40px;"
                        v-html="wordList[percent-1].wordRed"
                      ></span>
                    </a-col>
                  </a-row>
                  <div>
                    <span style="marginRight:40px">
                      <a-button
                        size="large"
                        style="font-size:25px;color:white;font-family:Arial,Helvetica,sans-serif;width:200px;background-color:#1890ff;height:60px;border-radius:15px 15px 15px 15px;"
                        @click="challengeOne"
                      >熟悉</a-button>
                    </span>
                    <span>
                      <a-button
                        size="large"
                        style="font-size:25px;color:white;font-family:Arial,Helvetica,sans-serif;width:200px;background-color:red;height:60px;border-radius:15px 15px 15px 15px;"
                        @click="goLearnDetail"
                      >不熟悉</a-button>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 不熟悉单词详细页面 -->
          <div
            class="editorciyusuji"
            v-if="startLearnOne"
          >
            <div style="margin:10px 20px">
              <a-row :gutter="16">
                <a-col
                  :span="19"
                  :offset="1"
                  style="line-height:40px;"
                >
                  <a-progress
                    :percent="percents"
                    :showInfo="false"
                    :strokeWidth="20"
                    strokeColor="#ff5500"
                  />
                </a-col>
                <a-col :span="4">
                  <a-button
                    disabled
                    size="large"
                    style="border-radius:50px;border:2px solid #ff5500;font-size:22px;font-weigth:bold;color:#000;"
                  >{{ percent }}/{{ total }}</a-button>
                </a-col>
              </a-row>
              <div>
                <div style="float:left;width:50%">
                  <div
                    style="padding:30px 0px 10px 50px;font-size:40px;"
                    align="left"
                  >
                    {{ wordList[percent-1].word }}
                    <div
                      style="font-size:30px;width:100%"
                      v-html="wordList[percent-1].wordRed"
                    ></div>
                  </div>
                  <div
                    align="left"
                    style="padding:0px 0px 0px 20px"
                  >
                    <span style="font-size:18px;marginBottom:20px;">英:{{ wordList[percent-1].britishPhonetic }}
                      <a
                        :title="playFlag?'暂停':'播放'"
                        href="javascript:;"
                        @click="startPlayOrPause"
                      >
                        <a-icon
                          type="sound"
                          style="fontSize:18px;padding:0px 0px 0px 18px;"
                        />
                      </a>
                      <audio
                        v-if="wordList[percent-1].britishSound !==null && wordList[percent-1].britishSound !==''"
                        ref="audio"
                        :src="wordList[percent-1].britishSound"
                        controls
                        hidden="true"
                        autoplay="autoplay"
                        @play="onPlay"
                        @pause="onPause"
                        @error="onError(percent)"
                        @timeupdate="onTimeupdate"
                      >
                      </audio>
                      <audio
                        v-else
                        ref="audio"
                        src=""
                        @play="onPlay"
                        @pause="onPause"
                        @error="onError"
                        @timeupdate="onTimeupdate"
                      >
                      </audio>
                    </span>
                    <span style="font-size:18PX;marginBottom:20px;marginLeft:20px;">美:{{ wordList[percent-1].americanPhonetic }}

                      <a
                        :title="playFlag?'暂停':'播放'"
                        href="javascript:;"
                        @click="startPlayOrPauseUSA"
                      >
                        <a-icon
                          type="sound"
                          style="fontSize:18px;padding:0px 0px 0px 18px;"
                        />
                      </a>
                      <audio
                        v-if="wordList[percent-1].americanSound !==null && wordList[percent-1].americanSound !==''"
                        ref="audioUSA"
                        :src="wordList[percent-1].americanSound"
                        @play="onPlayUSA"
                        @pause="onPauseUSA"
                        @error="onError(percent)"
                        @timeupdate="onTimeupdate"
                      >
                      </audio>
                      <audio
                        v-else
                        ref="audioUSA"
                        src=""
                        @play="onPlayUSA"
                        @pause="onPauseUSA"
                        @error="onError"
                        @timeupdate="onTimeupdate"
                      >
                      </audio>
                    </span>
                  </div>
                  <div style="font-size:18px;padding:10px 0px 0px 20px">
                    简单词义：{{ wordList[percent-1].mainMeaning }}
                  </div>

                  <div
                    style="font-size:18px;padding:10px 0px 0px 20px;width:350px; height:280px;"
                    align="center"
                  >
                    <img
                      :src="wordList[percent-1].image"
                      width="100%"
                      height="100%"
                    />
                  </div>
                </div>
                <div style="float:right;width:50%;height:100%">
                  <div style="font-size:18px;padding:55px 10px 10px 10px">
                    详细词义：{{ wordList[percent-1].detailMeaning }}
                  </div>
                  <div style="font-size:18px;padding:0px 10px 18px 0px">
                    <div
                      size="large"
                      align="center"
                      style="line-height:45px;font-size:25px;color:white;font-family:Arial,Helvetica,sans-serif;width:150px;background-color:#1890ff;height:45px;border-radius:15px 15px 15px 15px;"
                    >
                      <span>记忆方法</span>
                    </div>
                    <div
                      style="padding:10px 0px 10px 10px;"
                      v-if="wordList[percent-1].memoryMethod !=null && wordList[percent-1].memoryMethod !=''"
                    >
                      {{ wordList[percent-1].memoryMethod | html2Text }}
                    </div>
                    <div
                      v-else
                      style="padding:30px 0px 30px 10px;font-size:25px"
                    >
                      无
                    </div>
                    <div
                      size="large"
                      align="center"
                      style="line-height:45px;font-size:25px;color:white;font-family:Arial,Helvetica,sans-serif;width:150px;background-color:#1890ff;height:45px;border-radius:15px 15px 15px 15px;"
                    >
                      <span>例句</span>
                    </div>
                    <div
                      style="paddingTop:10px"
                      v-if="wordList[percent-1].example !=null && wordList[percent-1].example !=''"
                      v-html="wordList[percent-1].example "
                    >

                    </div>
                    <div
                      v-else
                      style="padding:30px 0px 10px 10px;font-size:25px"
                    >
                      无
                    </div>
                    <a-button
                      size="large"
                      style="position:absolute;bottom:70px;right:100px;marginTop:10px;font-size:25px;color:white;font-family:Arial,Helvetica,sans-serif;width:150px;background-color:#FF6C00;height:53px;border-radius:15px 15px 15px 15px;"
                      @click="challengeOne"
                    >GO
                      <a-icon type="caret-right" />
                    </a-button>
                  </div>
                </div>
              </div>
              <!-- <div style="width:90%;position:absolute;bottom:-23px" align="center">
                <a-button
                  size="large"
                  style="font-size:25px;color:white;font-family:Arial,Helvetica,sans-serif;width:150px;background-color:#1890ff;height:53px;border-radius:15px 15px 15px 15px;"
                  @click="learn"
                >单词列表</a-button>
                <a-button
                  v-if="flashType === '0'"
                  :disabled="isDisable"
                  size="large"
                  style="marginLeft:50px;font-size:25px;color:white;font-family:Arial,Helvetica,sans-serif;width:150px;background-color:#1890ff;height:53px;border-radius:15px 15px 15px 15px;"
                  @click="challengeAll"
                >开始挑战</a-button>
                <a-button
                  v-if="flashType === '1'"
                  :disabled="isDisable"
                  size="large"
                  style="marginLeft:50px;font-size:25px;color:white;font-family:Arial,Helvetica,sans-serif;width:150px;background-color:#1890ff;height:53px;border-radius:15px 15px 15px 15px;"
                  @click="challengeAll"
                >去做作业</a-button>
                <a-button
                  v-if="flashType === '2'"
                  :disabled="isDisable"
                  size="large"
                  style="marginLeft:50px;font-size:25px;color:white;font-family:Arial,Helvetica,sans-serif;width:150px;background-color:#1890ff;height:53px;border-radius:15px 15px 15px 15px;"
                  @click="challengeAll"
                >开始复习</a-button>
              </div> -->
            </div>
          </div>

          <!-- 学习一个单词，三道题 -->
          <div
            class="editorciyusuji"
            v-if="challengeThree"
          >
            <div style="margin:10px 20px">
              <a-row :gutter="16">
                <a-col
                  :span="19"
                  :offset="1"
                  style="line-height:40px;"
                >
                  <a-progress
                    :percent="percents"
                    :showInfo="false"
                    :strokeWidth="20"
                    strokeColor="#ff5500"
                  />
                </a-col>
                <a-col :span="4">
                  <a-button
                    disabled
                    size="large"
                    style="border-radius:50px;border:2px solid #ff5500;font-size:22px;font-weigth:bold;color:#000;"
                  >{{ percent }}/{{ total }}</a-button>
                </a-col>
              </a-row>
              <div align="center">
                <div
                  v-if="spell"
                  style="font-weight:520;display:block;font-size:35px;margin-block-start:0.67em;margin-block-end: 0.67em;marginBottom:20px;paddingTop:30px"
                >
                  请拼写单词
                </div>
                <div
                  v-if="EnToCh"
                  style="font-weight:520;display:block;font-size:35px;margin-block-start:0.67em;margin-block-end: 0.67em;marginBottom:20px;paddingTop:30px"
                >
                  请选择正确的语义
                </div>
                <div
                  v-if="ChToEn"
                  style="font-weight:520;display:block;font-size:35px;margin-block-start:0.67em;margin-block-end: 0.67em;marginBottom:20px;paddingTop:30px"
                >
                  请选择正确的单词
                </div>
              </div>

              <!-- 单词拼写题型 -->
              <div
                v-if="spell"
                style="display:block;font-size:35px;margin-block-start:0.67em;margin-block-end: 0.67em;"
              >

                <!-- 删除实时显示答案点击按钮 -->
                <div
                  @click="delectAnswersAll"
                  v-if="answers.length > 0"
                  style="cursor:pointer;font-weight:900px;font-size:50px;padding:90px 40px 0px 10px;height:68px;float:right"
                >
                  <a-tooltip placement="topLeft">
                    <template slot="title">
                      <span>清空已选</span>
                    </template>
                    <a-icon
                      type="delete"
                      theme="twoTone"
                    />
                  </a-tooltip>
                </div>

                <div style="height:48px;margin:0px 100px 0px 100px;">
                  <span style="line-height:48px;font-size:22px;width:130px;height:48px;">
                    <a
                      :title="playFlag?'暂停':'播放'"
                      href="javascript:;"
                      @click="startPlayOrPauseUSA"
                    >
                      <a-button
                        icon="sound"
                        style="background-image: url(/huise.png);border:none;fontSize:40px;line-height:48px;font-size:22px;color:#1890ff;font-family:Arial,Helvetica,sans-serif;height:48px;width:48px"
                        type="dashed"
                        shape="circle"
                      >

                      </a-button>
                    </a>
                    <audio
                      v-if="wordList[percent-1].americanSound !==null && wordList[percent-1].americanSound !==''"
                      ref="audioUSA"
                      :src="wordList[percent-1].americanSound"
                      @play="onPlayUSA"
                      controls
                      hidden="true"
                      autoplay="autoplay"
                      @pause="onPauseUSA"
                      @error="onError(percent)"
                      @timeupdate="onTimeupdate"
                    >
                    </audio>
                    <audio
                      v-else
                      ref="audio"
                      src=""
                      @play="onPlayUSA"
                      @pause="onPauseUSA"
                      @error="onError"
                      @timeupdate="onTimeupdate"
                    >
                    </audio>
                  </span>
                  <a-button
                    v-if="!show"
                    style="line-height:48px;margin:0px 0px 30px 30px;font-size:22px;color:white;font-family:Arial,Helvetica,sans-serif;width:130px;background-color:#1890ff;height:48px;border-radius:15px 15px 15px 15px;"
                    @click="showMean"
                  >
                    显示词义
                  </a-button>
                  <a-button
                    v-if="show"
                    style=" line-height:48px;margin:0px 0px 30px 30px;font-size:22px;color:white;font-family:Arial,Helvetica,sans-serif;width:130px;background-color:#1890ff;height:48px;border-radius:15px 15px 15px 15px;"
                    @click="hiddenMean"
                  >
                    隐藏词义
                  </a-button>
                  <span
                    v-if="show"
                    style="font-weight:100px;font-size:25px;paddingLeft:10px"
                  >

                    <ellipsis
                      :length="59"
                      tooltip
                    >
                      {{ wordList[percent-1].mainMeaning }}
                    </ellipsis>
                  </span>
                  <div
                    class="TipsMessages"
                    v-show="TipsMessages"
                    style="width:70%;position:absolute;top:278px;font-size:25px;left:350px"
                  >
                    正确答案是：{{ wordList[percent-1].word }}
                  </div>
                  <!-- 实时显示拼写区域 -->
                  <div
                    style="font-weight:900px;font-size:50px;height:68px"
                    align="center"
                  >
                    <span>
                      {{ answers }}
                    </span>
                  </div>

                  <!-- 错误符号 -->
                  <div
                    v-if="answersWrong"
                    style="position:absolute;top:300px;right:120px;font-weight:900px;font-size:50px;padding:5px 40px 10px 10px;height:68px;float:right;color:red"
                  >
                    <a-icon
                      type="close-circle"
                      theme="twoTone"
                      twoToneColor="red"
                    />
                  </div>
                  <!-- 正确符号 -->
                  <div
                    v-if="answersCurrect"
                    style="position:absolute;top:300px;right:120px;font-size:50px;padding:5px 40px 0px 10px;height:68px;float:right;color:green"
                  >
                    <a-icon
                      type="check-circle"
                      theme="twoTone"
                      twoToneColor="#52c41a"
                    />
                  </div>
                  <hr style="height:5px;border:none;border-top:5px solid  green;" />
                  <div align="center">
                    <span
                      v-for="(optionItem,index) in option"
                      :key="index"
                    >
                      <!-- 点击过的选项 -->
                      <a-button
                        icon="minus"
                        type="danger"
                        v-if="optionItem.flag=== 'true'"
                        @click="cleanAnswer(optionItem)"
                        style="width:168px;line-height:48px;margin:0px 5px 10px 5px;font-size:22px;font-family:Arial,Helvetica,sans-serif;height:48px;border-radius:15px 15px 15px 15px;"
                      >
                        <span>{{ optionItem.data }}</span>
                      </a-button>
                      <!-- 没点击过的选项 -->
                      <a-button
                        icon="plus"
                        type="primary"
                        v-else
                        @click="addAnswer(optionItem)"
                        style="width:168px;line-height:48px;margin:0px 5px 10px 5px;font-size:22px;font-family:Arial,Helvetica,sans-serif;height:48px;border-radius:15px 15px 15px 15px;"
                      >
                        <span>{{ optionItem.data }}</span>
                      </a-button>
                    </span>
                  </div>
                </div>
                <div
                  style="width:90%;position:absolute;bottom:75px"
                  align="center"
                >
                  <a-button
                    :disabled="isDisable"
                    v-if="answers.length > 0"
                    size="large"
                    style="font-size:25px;color:white;font-family:Arial,Helvetica,sans-serif;width:150px;background-color:#FF6C00;height:53px;border-radius:15px 15px 15px 15px;"
                    @click="judgeSpell(answers)"
                  >确定</a-button>
                </div>
              </div>
              <!-- 英译汉题型 -->
              <div
                v-if="EnToCh"
                style="line-height:48px;font-size:22px;height:48px;"
                align="center"
              >
                <a
                  :title="playFlag?'暂停':'播放'"
                  href="javascript:;"
                  @click="startPlayOrPauseUSA"
                >
                  <a-button
                    icon="sound"
                    style="background-image: url(/huise.png);border:none;fontSize:35px;line-height:48px;font-size:22px;color:#1890ff;font-family:Arial,Helvetica,sans-serif;height:48px;width:48px"
                    type="dashed"
                    shape="circle"
                  >
                  </a-button>
                </a>
                <span style="font-size:30px;paddingLeft:10px">{{ wordList[percent-1].word }}</span>
                <audio
                  v-if="wordList[percent-1].americanSound !==null && wordList[percent-1].americanSound !==''"
                  ref="audioUSA"
                  :src="wordList[percent-1].americanSound"
                  @play="onPlayUSA"
                  controls
                  hidden="true"
                  autoplay="autoplay"
                  @pause="onPauseUSA"
                  @error="onError(percent)"
                  @timeupdate="onTimeupdate"
                >
                </audio>
                <audio
                  v-else
                  ref="audio"
                  src=""
                  @play="onPlayUSA"
                  @pause="onPauseUSA"
                  @error="onError"
                  @timeupdate="onTimeupdate"
                >
                </audio>

                <div style="font-size:30px;marginTop:8px">
                  <span
                    v-for="(itemEnToCh,index) in optionEnToCh"
                    :key="index"
                  >

                    <a-button
                      :disabled="isDisable"
                      type="primary"
                      @click="judgeEnToCh(itemEnToCh)"
                      style="width:650px;line-height:48px;margin:15px 0px 10px 100px;font-size:22px;font-family:Arial,Helvetica,sans-serif;height:48px;border-radius:15px 15px 15px 15px;"
                    >
                      <span>{{ itemEnToCh.data }}</span>
                    </a-button>
                    <!-- 错误符号 -->
                    <span
                      v-if="itemEnToCh.flag === false"
                      style="width:75px;font-size:50px;padding:15px 40px 0px 10px;height:68px;float:right;color:red"
                    >
                      <a-icon
                        type="close-circle"
                        theme="twoTone"
                        twoToneColor="red"
                      />
                    </span>
                    <!-- 正确符号 -->
                    <span
                      v-if="itemEnToCh.flag === true"
                      style="width:75px;font-size:50px;padding:15px 40px 0px 10px;height:68px;float:right;color:green"
                    >
                      <a-icon
                        type="check-circle"
                        theme="twoTone"
                        twoToneColor="#52c41a"
                      />
                    </span>
                    <!-- 占位 -->
                    <span
                      v-if="itemEnToCh.flag === ''"
                      style="width:75px;font-weight:900px;font-size:50px;padding:15px 40px 0px 10px;height:68px;float:right;color:red"
                    >
                    </span>
                  </span>
                </div>
              </div>
              <!-- 汉译英题型 -->
              <div
                v-if="ChToEn"
                style="line-height:48px;font-size:22px;height:48px;"
                align="center"
              >

                <span style="font-size:25px;paddingLeft:10px">{{ wordList[percent-1].mainMeaning }}</span>

                <div style="font-size:30px;marginTop:8px">
                  <span
                    v-for="(itemChToEn,index) in optionChToEn"
                    :key="index"
                  >

                    <a-button
                      :disabled="isDisable"
                      type="primary"
                      @click="judgeChToEn(itemChToEn)"
                      style="width:650px;line-height:48px;margin:15px 0px 10px 100px;font-size:22px;font-family:Arial,Helvetica,sans-serif;height:48px;border-radius:15px 15px 15px 15px;"
                    >
                      <span>{{ itemChToEn.data }}</span>
                    </a-button>
                    <!-- 错误符号 -->
                    <span
                      v-if="itemChToEn.flag === false"
                      style="width:75px;font-size:50px;padding:15px 40px 0px 10px;height:68px;float:right;color:red"
                    >
                      <a-icon
                        type="close-circle"
                        theme="twoTone"
                        twoToneColor="red"
                      />
                    </span>
                    <!-- 正确符号 -->
                    <span
                      v-if="itemChToEn.flag === true"
                      style="width:75px;font-size:50px;padding:15px 40px 0px 10px;height:68px;float:right;color:green"
                    >
                      <a-icon
                        type="check-circle"
                        theme="twoTone"
                        twoToneColor="#52c41a"
                      />
                    </span>
                    <!-- 占位 -->
                    <span
                      v-if="itemChToEn.flag === ''"
                      style="width:75px;font-weight:900px;font-size:50px;padding:15px 40px 0px 10px;height:68px;float:right;color:red"
                    >
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!-- 挑战所有-->
          <div
            class="editorciyusuji"
            v-if="startChallenge"
          >
            <div style="margin:10px 20px">
              <a-row :gutter="16">
                <a-col
                  :span="19"
                  :offset="1"
                  style="line-height:40px;"
                >
                  <a-progress
                    :percent="percents"
                    :showInfo="false"
                    :strokeWidth="20"
                    strokeColor="#ff5500"
                  />
                </a-col>
                <a-col :span="4">
                  <a-button
                    disabled
                    size="large"
                    style="border-radius:50px;border:2px solid #ff5500;font-size:22px;font-weigth:bold;color:#000;"
                  >{{ percent }}/{{ total }}</a-button>
                </a-col>
              </a-row>
              <div align="center">
                <div
                  v-if="spell"
                  style="font-weight:520;display:block;font-size:35px;margin-block-start:0.67em;margin-block-end: 0.67em;marginBottom:20px;paddingTop:30px"
                >
                  请拼写单词
                </div>
                <div
                  v-if="EnToCh"
                  style="font-weight:520;display:block;font-size:35px;margin-block-start:0.67em;margin-block-end: 0.67em;marginBottom:20px;paddingTop:30px"
                >
                  请选择正确的语义
                </div>
                <div
                  v-if="ChToEn"
                  style="font-weight:520;display:block;font-size:35px;margin-block-start:0.67em;margin-block-end: 0.67em;marginBottom:20px;paddingTop:30px"
                >
                  请选择正确的单词
                </div>
              </div>

              <!-- 单词拼写题型 -->
              <div
                v-if="spell"
                style="display:block;font-size:35px;margin-block-start:0.67em;margin-block-end: 0.67em;"
              >

                <!-- 删除实时显示答案点击按钮 -->
                <div
                  @click="delectAnswersAll"
                  v-if="answers.length > 0"
                  style="cursor:pointer;font-weight:900px;font-size:50px;padding:90px 40px 0px 10px;height:68px;float:right"
                >
                  <a-tooltip placement="topLeft">
                    <template slot="title">
                      <span>清空已选</span>
                    </template>
                    <a-icon
                      type="delete"
                      theme="twoTone"
                    />
                  </a-tooltip>
                </div>

                <div style="height:48px;margin:0px 100px 0px 100px;">
                  <span style="line-height:48px;font-size:22px;width:130px;height:48px;">
                    <a
                      :title="playFlag?'暂停':'播放'"
                      href="javascript:;"
                      @click="startPlayOrPauseUSA"
                    >
                      <a-button
                        icon="sound"
                        style="background-image: url(/huise.png);border:none;fontSize:40px;line-height:48px;font-size:22px;color:#1890ff;font-family:Arial,Helvetica,sans-serif;height:48px;width:48px"
                        type="dashed"
                        shape="circle"
                      >

                      </a-button>
                    </a>
                    <audio
                      v-if="wordListAll[percent-1].data.americanSound !==null && wordListAll[percent-1].data.americanSound !==''"
                      ref="audioUSA"
                      :src="wordListAll[percent-1].data.americanSound"
                      @play="onPlayUSA"
                      controls
                      hidden="true"
                      autoplay="autoplay"
                      @pause="onPauseUSA"
                      @error="onError(percent)"
                      @timeupdate="onTimeupdate"
                    >
                    </audio>
                    <audio
                      v-else
                      ref="audio"
                      src=""
                      @play="onPlayUSA"
                      @pause="onPauseUSA"
                      @error="onError"
                      @timeupdate="onTimeupdate"
                    >
                    </audio>
                  </span>
                  <a-button
                    v-if="!show"
                    style="line-height:48px;margin:0px 0px 30px 30px;font-size:22px;color:white;font-family:Arial,Helvetica,sans-serif;width:130px;background-color:#1890ff;height:48px;border-radius:15px 15px 15px 15px;"
                    @click="showMean"
                  >
                    显示词义
                  </a-button>
                  <a-button
                    v-if="show"
                    style=" line-height:48px;margin:0px 0px 30px 30px;font-size:22px;color:white;font-family:Arial,Helvetica,sans-serif;width:130px;background-color:#1890ff;height:48px;border-radius:15px 15px 15px 15px;"
                    @click="hiddenMean"
                  >
                    隐藏词义
                  </a-button>
                  <span
                    v-if="show"
                    style="font-weight:100px;font-size:25px;paddingLeft:10px"
                  >
                    <ellipsis
                      :length="59"
                      tooltip
                    >
                      {{ wordListAll[percent-1].data.mainMeaning }}
                    </ellipsis>
                  </span>
                  <div
                    class="TipsMessages"
                    v-show="TipsMessages"
                    style="width:70%;position:absolute;top:278px;font-size:25px;left:350px"
                  >
                    正确答案是：{{ wordListAll[percent-1].data.word }}
                  </div>
                  <!-- 实时显示拼写区域 -->
                  <div
                    style="font-weight:900px;font-size:50px;height:68px"
                    align="center"
                  >
                    <span>
                      {{ answers }}
                    </span>
                  </div>

                  <!-- 错误符号 -->
                  <div
                    v-if="answersWrong"
                    style="position:absolute;top:300px;right:120px;font-weight:900px;font-size:50px;padding:5px 40px 10px 10px;height:68px;float:right;color:red"
                  >
                    <a-icon
                      type="close-circle"
                      theme="twoTone"
                      twoToneColor="red"
                    />
                  </div>
                  <!-- 正确符号 -->
                  <div
                    v-if="answersCurrect"
                    style="position:absolute;top:300px;right:120px;font-size:50px;padding:5px 40px 0px 10px;height:68px;float:right;color:green"
                  >
                    <a-icon
                      type="check-circle"
                      theme="twoTone"
                      twoToneColor="#52c41a"
                    />
                  </div>
                  <hr style="height:5px;border:none;border-top:5px solid  green;" />
                  <div align="center">
                    <span
                      v-for="(optionItem,index) in option"
                      :key="index"
                    >
                      <!-- 点击过的选项 -->
                      <a-button
                        icon="minus"
                        type="danger"
                        v-if="optionItem.flag=== 'true'"
                        @click="cleanAnswer(optionItem)"
                        style="width:168px;line-height:48px;margin:0px 5px 10px 5px;font-size:22px;font-family:Arial,Helvetica,sans-serif;height:48px;border-radius:15px 15px 15px 15px;"
                      >
                        <span>{{ optionItem.data }}</span>
                      </a-button>
                      <!-- 没点击过的选项 -->
                      <a-button
                        icon="plus"
                        type="primary"
                        v-else
                        @click="addAnswer(optionItem)"
                        style="width:168px;line-height:48px;margin:0px 5px 10px 5px;font-size:22px;font-family:Arial,Helvetica,sans-serif;height:48px;border-radius:15px 15px 15px 15px;"
                      >
                        <span>{{ optionItem.data }}</span>
                      </a-button>
                    </span>
                  </div>
                </div>
                <div
                  style="width:90%;position:absolute;bottom:75px"
                  align="center"
                >
                  <a-button
                    :disabled="isDisable"
                    v-if="answers.length > 0"
                    size="large"
                    style="font-size:25px;color:white;font-family:Arial,Helvetica,sans-serif;width:150px;background-color:#FF6C00;height:53px;border-radius:15px 15px 15px 15px;"
                    @click="challengeJudgeSpell(answers)"
                  >确定</a-button>
                </div>
              </div>
              <!-- 英译汉题型 -->
              <div
                v-if="EnToCh"
                style="line-height:48px;font-size:22px;height:48px;"
                align="center"
              >
                <a
                  :title="playFlag?'暂停':'播放'"
                  href="javascript:;"
                  @click="startPlayOrPauseUSA"
                >
                  <a-button
                    icon="sound"
                    style="background-image: url(/huise.png);border:none;fontSize:35px;line-height:48px;font-size:22px;color:#1890ff;font-family:Arial,Helvetica,sans-serif;height:48px;width:48px"
                    type="dashed"
                    shape="circle"
                  >
                  </a-button>
                </a>
                <span style="font-size:30px;paddingLeft:10px">{{ wordListAll[percent-1].data.word }}</span>
                <audio
                  v-if="wordListAll[percent-1].data.americanSound !==null && wordListAll[percent-1].data.americanSound !==''"
                  ref="audioUSA"
                  :src="wordListAll[percent-1].data.americanSound"
                  @play="onPlayUSA"
                  controls
                  hidden="true"
                  autoplay="autoplay"
                  @pause="onPauseUSA"
                  @error="onError(percent)"
                  @timeupdate="onTimeupdate"
                >
                </audio>
                <audio
                  v-else
                  ref="audio"
                  src=""
                  @play="onPlayUSA"
                  @pause="onPauseUSA"
                  @error="onError"
                  @timeupdate="onTimeupdate"
                >
                </audio>

                <div style="font-size:30px;marginTop:8px">
                  <span
                    v-for="(itemEnToCh,index) in optionEnToCh"
                    :key="index"
                  >

                    <a-button
                      :disabled="isDisable"
                      type="primary"
                      @click="challengeJudgeEnToCh(itemEnToCh)"
                      style="width:650px;line-height:48px;margin:15px 0px 10px 100px;font-size:22px;font-family:Arial,Helvetica,sans-serif;height:48px;border-radius:15px 15px 15px 15px;"
                    >
                      <span>{{ itemEnToCh.data }}</span>
                    </a-button>
                    <!-- 错误符号 -->
                    <span
                      v-if="itemEnToCh.flag === false"
                      style="width:75px;font-size:50px;padding:15px 40px 0px 10px;height:68px;float:right;color:red"
                    >
                      <a-icon
                        type="close-circle"
                        theme="twoTone"
                        twoToneColor="red"
                      />
                    </span>
                    <!-- 正确符号 -->
                    <span
                      v-if="itemEnToCh.flag === true"
                      style="width:75px;font-size:50px;padding:15px 40px 0px 10px;height:68px;float:right;color:green"
                    >
                      <a-icon
                        type="check-circle"
                        theme="twoTone"
                        twoToneColor="#52c41a"
                      />
                    </span>
                    <!-- 占位 -->
                    <span
                      v-if="itemEnToCh.flag === ''"
                      style="width:75px;font-weight:900px;font-size:50px;padding:15px 40px 0px 10px;height:68px;float:right;color:red"
                    >
                    </span>
                  </span>
                </div>
              </div>
              <!-- 汉译英题型 -->
              <div
                v-if="ChToEn"
                style="line-height:48px;font-size:22px;height:48px;"
                align="center"
              >

                <span style="font-size:25px;paddingLeft:10px">{{ wordListAll[percent-1].data.mainMeaning }}</span>

                <div style="font-size:30px;marginTop:8px">
                  <span
                    v-for="(itemChToEn,index) in optionChToEn"
                    :key="index"
                  >

                    <a-button
                      type="primary"
                      :disabled="isDisable"
                      @click="challengeJudgeChToEn(itemChToEn)"
                      style="width:650px;line-height:48px;margin:15px 0px 10px 100px;font-size:22px;font-family:Arial,Helvetica,sans-serif;height:48px;border-radius:15px 15px 15px 15px;"
                    >
                      <span>{{ itemChToEn.data }}</span>
                    </a-button>
                    <!-- 错误符号 -->
                    <span
                      v-if="itemChToEn.flag === false"
                      style="width:75px;font-size:50px;padding:15px 40px 0px 10px;height:68px;float:right;color:red"
                    >
                      <a-icon
                        type="close-circle"
                        theme="twoTone"
                        twoToneColor="red"
                      />
                    </span>
                    <!-- 正确符号 -->
                    <span
                      v-if="itemChToEn.flag === true"
                      style="width:75px;font-size:50px;padding:15px 40px 0px 10px;height:68px;float:right;color:green"
                    >
                      <a-icon
                        type="check-circle"
                        theme="twoTone"
                        twoToneColor="#52c41a"
                      />
                    </span>
                    <!-- 占位 -->
                    <span
                      v-if="itemChToEn.flag === ''"
                      style="width:75px;font-weight:900px;font-size:50px;padding:15px 40px 0px 10px;height:68px;float:right;color:red"
                    >
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </a-col>
      </a-spin>
      <!-- 结果页 -->
      <a-col
        v-if="resultView"
        :span="24"
        class="imageflash"
        style="height:700px; border-radius:5px;"
      >
        <div
          align="center"
          style="line-height:40px;margin:15px"
        >
          <div
            v-if="resultView && flashType === '0'"
            style="color:white;font-weight:520;display:block;font-size:30px;"
          >
            您已完成全部挑战
          </div>
          <div
            v-if="resultView && flashType === '1'"
            style="color:white;font-weight:520;display:block;font-size:30px;"
          >
            您已完成此作业
          </div>
          <div
            v-if="resultView && flashType === '2'"
            style="color:white;font-weight:520;display:block;font-size:30px;"
          >
            您已完成本页复习
          </div>
          <div
            v-if="resultView"
            style="color:white;font-weight:520;display:block;font-size:30px;"
          >
            <a-rate
              style="font-size:28px"
              v-model=" resultData.totalScore"
              allowHalf
              disabled
            />
          </div>
        </div>
        <div
          class="resultViewEditorciyusuji"
          v-if="resultView"
        >
          <div style="margin:30px 20px">
            <a-row
              type="flex"
              justify="start"
              v-for="(itemWord,index) in resultData.wordScoreList"
              :key="index"
            >
              <a-col
                :class="index % 2 == 0 ? 'ciyusujiWordCss' : 'ciyusujiWordCss2'"
                :span="22"
                style="padding:0px 15px;line-height:35px;font-size:22px;margin:0px 40px"
              >
                <div style="float:left">
                  {{ itemWord.word }}
                </div>
                <div style="float:right">
                  <a-rate
                    style="font-size:16px"
                    v-model="itemWord.score"
                    allowHalf
                    disabled
                  />
                </div>
              </a-col>
            </a-row>
          </div>
        </div>
        <div
          v-if="resultView && flashType === '2'"
          style="color:white;font-weight:520;display:block;font-size:30px;"
          align="center"
        >
          <a-button
            v-if="flashType === '2'"
            :disabled="isDisable"
            size="large"
            style="bottom:60px;font-size:25px;color:white;font-family:Arial,Helvetica,sans-serif;width:150px;background-color:#1890ff;height:53px;border-radius:15px 15px 15px 15px;"
            @click="flashWrong(1,'2')"
          >继续复习</a-button>
        </div>
      </a-col>
    </div>
  </a-modal>
</template>
<script>
import { mapGetters } from 'vuex'
import { getWordList } from '@/api/datum/word'
import Ellipsis from '@/components/Ellipsis'
import { addObj, addWrongWords, getWrongWords, deleteWrongWords, addHomework } from '@/api/datum/ciyusuji'
export default {
  components: {
    mapGetters,
    Ellipsis
  },
  created () {
  },
  computed: {
    ...mapGetters(['studentId'])
  },
  props: {
  },
  data () {
    return {
      // loading状态
      spinning: true,
      indicator: <a-icon type="loading" style="font-size: 24px" spin />,
      // 按钮状态
      isDisable: false,
      // 结果页
      resultView: false,
      // 拼写题型标题
      spell: false,
      // 英译汉题型
      EnToCh: false,
      // 汉译英题型
      ChToEn: false,
      // 错误符号
      answersWrong: false,
      // 正确符号
      answersCurrect: false,
      // 提示信息
      TipsMessages: false,
      endOption: '',
      answerKey: '',
      answer: '',
      answers: '',
      answersList: [],
      // 拼写选项
      option: [],
      // 英译汉选项
      optionEnToCh: [],
      // 英译汉选项
      optionChToEn: [],
      // 隐藏词义
      show: false,
      resultData: [],
      url: '',
      audio: {
        playing: false
      },
      audioUSA: {
        playing: false
      },
      playFlag: false,
      onlyOnePlaying: false,
      cTime: null,
      dTime: null,
      current: 0,
      percent: 1,
      percents: 0,
      // 画面一览界面
      start: true,
      // 开始学习单词列表界面
      startLearn: false,
      // 不熟悉单词详细页面
      startLearnOne: false,
      //  挑战一个单词，三道题
      challengeThree: false,
      // 开始挑战
      startChallenge: false,
      total: 0,
      queryParam: {},
      queryParamWrongWords: {},
      // 上传参数
      parameter: [],
      // 删除参数
      deleceParameter: [],
      // 保存作业参数
      homeworkParameter: [],
      // 保存错误单词
      parameterWrongWord: [],
      wordList: {},
      wordListAll: {},
      vable: false,
      loading: true,
      bookId: '',
      unitId: '',
      period: '',
      press: '',
      required: '',
      elective: '',
      grade: '',
      study: '',
      volume: '',
      name: '',
      scoreId: '',
      flashType: '',
      homeworkName: '',
      examPaperId: '',
      homeworkId: ''
    }
  },
  filters: {

    volumeFolter (volume) {
      const volumeMap = {
        1: '上册',
        2: '下册',
        3: '全一册'
      }
      return volumeMap[volume]
    },
    studyFolter (value) {
      const studyMap = {
        1: '必修一',
        2: '必修二',
        3: '必修三',
        4: '必修四',
        5: '必修五'
      }
      return studyMap[value]
    },
    studyFolter2 (value) {
      const studyMap = {
        1: '选修六',
        2: '选修七',
        3: '选修八',
        4: '选修九',
        5: '选修十',
        6: '选修十一'
      }
      return studyMap[value]
    },
    gradeFolter (grade) {
      const gradeMap = {
        1: '一年级',
        2: '二年级',
        3: '三年级',
        4: '四年级',
        5: '五年级',
        6: '六年级',
        7: '七年级',
        8: '八年级',
        9: '九年级',
        10: '高一',
        11: '高二',
        12: '高三'
      }
      return gradeMap[grade]
    }
  },

  // mounted () {
  //   this.$set(this.wordListAll, 'flag', '1')
  // },
  methods: {

    // 挑战所有
    challengeAll () {
      this.isDisable = true
      if (this.flashType === '0') {
        this.wordListAll = {}
        this.queryParam.unitId = this.unitId
        getWordList(this.queryParam).then(res => {
          this.wordList = res.result.data
          this.wordListNew = this.wordList.concat(this.wordList).concat(this.wordList)
          // console.log(' wordListNew' + JSON.stringify(this.wordListNew))
          var try3 = []
          for (var k = 0; k < this.wordListNew.length; k++) {
            if (this.wordListNew.length / 3 * 2 <= k && k < this.wordListNew.length) {
              try3[k] = { key: k + 1, data: this.wordListNew[k], flag: '2' }
            } else if (this.wordListNew.length / 3 <= k && k < this.wordListNew.length / 3 * 2) {
              try3[k] = { key: k + 1, data: this.wordListNew[k], flag: '1' }
            } else {
              try3[k] = { key: k + 1, data: this.wordListNew[k], flag: '0' }
            }
          }
          // console.log(' try3' + JSON.stringify(try3))
          this.total = try3.length
          this.percents = (100 / this.total)
          this.percent = 1
          var arrLen = try3.length
          var b = try3
          // 创建数组 存放下标数
          var try1 = []
          for (var f = 0; f < arrLen; f++) {
            try1[f] = f
          }
          // 创建数组 生成随机下标数
          var try2 = []
          for (var g = 0; g < arrLen; g++) {
            try2[g] = try1.splice(Math.floor(Math.random() * try1.length), 1)
          }
          // 创建数组，生成对应随机下标数的数组
          var try4 = [{}, {}, {}]
          for (var h = 0; h < arrLen; h++) {
            try4[h] = b[try2[h]]
          }
          // 打乱后的顺序
          this.wordListAll = try4
          // console.log(' this.wordListAll' + JSON.stringify(this.wordListAll))
          // 答题modal为true
          this.challengeThree = false
          // 其他为false
          this.startChallenge = true
          this.startLearn = false
          this.startLearnOne = false
          this.start = false
          this.q = this.percent - 1

          this.parameter = []
          this.deleceParameter = []
          this.homeworkParameter = []
          // 词语拼写
          if (this.wordListAll[this.q].flag === '0') {
            this.challengeSpell(this.q)
          }
          // 英译汉
          if (this.wordListAll[this.q].flag === '1') {
            this.challengeEnToCh(this.q)
          }
          // 汉译英
          if (this.wordListAll[this.q].flag === '2') {
            this.challengeChToEn(this.q)
          }
        })
      }
      if (this.flashType === '1') {
        this.wordListAll = {}
        this.queryParam.unitId = this.unitId
        getWordList(this.queryParam).then(res => {
          this.wordList = res.result.data
          this.wordListNew = this.wordList.concat(this.wordList).concat(this.wordList)
          var try3 = []
          for (var k = 0; k < this.wordListNew.length; k++) {
            if (this.wordListNew.length / 3 * 2 <= k && k < this.wordListNew.length) {
              try3[k] = { key: k + 1, data: this.wordListNew[k], flag: '2' }
            } else if (this.wordListNew.length / 3 <= k && k < this.wordListNew.length / 3 * 2) {
              try3[k] = { key: k + 1, data: this.wordListNew[k], flag: '1' }
            } else {
              try3[k] = { key: k + 1, data: this.wordListNew[k], flag: '0' }
            }
          }
          this.total = try3.length
          this.percents = (100 / this.total)
          this.percent = 1
          var arrLen = try3.length
          var b = try3
          // 创建数组 存放下标数
          var try1 = []
          for (var f = 0; f < arrLen; f++) {
            try1[f] = f
          }
          // 创建数组 生成随机下标数
          var try2 = []
          for (var g = 0; g < arrLen; g++) {
            try2[g] = try1.splice(Math.floor(Math.random() * try1.length), 1)
          }
          // 创建数组，生成对应随机下标数的数组
          var try4 = [{}, {}, {}]
          for (var h = 0; h < arrLen; h++) {
            try4[h] = b[try2[h]]
          }
          // 打乱后的顺序
          this.wordListAll = try4
          // 答题modal为true
          this.challengeThree = false
          // 其他为false
          this.startChallenge = true
          this.startLearn = false
          this.startLearnOne = false
          this.start = false
          this.q = this.percent - 1
          this.parameter = []
          this.deleceParameter = []
          // 词语拼写
          if (this.wordListAll[this.q].flag === '0') {
            this.challengeSpell(this.q)
          }
          // 英译汉
          if (this.wordListAll[this.q].flag === '1') {
            this.challengeEnToCh(this.q)
          }
          // 汉译英
          if (this.wordListAll[this.q].flag === '2') {
            this.challengeChToEn(this.q)
          }
        })
      }
      if (this.flashType === '2') {
        this.wordListAll = {}
        this.queryParamWrongWords.current = this.current
        getWrongWords(this.queryParamWrongWords).then(res => {
          this.wordList = res.result.data
          this.wordListNew = this.wordList.concat(this.wordList).concat(this.wordList)
          var try3 = []
          for (var k = 0; k < this.wordListNew.length; k++) {
            if (this.wordListNew.length / 3 * 2 <= k && k < this.wordListNew.length) {
              try3[k] = { key: k + 1, data: this.wordListNew[k], flag: '2' }
            } else if (this.wordListNew.length / 3 <= k && k < this.wordListNew.length / 3 * 2) {
              try3[k] = { key: k + 1, data: this.wordListNew[k], flag: '1' }
            } else {
              try3[k] = { key: k + 1, data: this.wordListNew[k], flag: '0' }
            }
          }
          this.total = try3.length
          this.percents = (100 / this.total)
          this.percent = 1
          var arrLen = try3.length
          var b = try3
          // 创建数组 存放下标数
          var try1 = []
          for (var f = 0; f < arrLen; f++) {
            try1[f] = f
          }
          // 创建数组 生成随机下标数
          var try2 = []
          for (var g = 0; g < arrLen; g++) {
            try2[g] = try1.splice(Math.floor(Math.random() * try1.length), 1)
          }
          // 创建数组，生成对应随机下标数的数组
          var try4 = [{}, {}, {}]
          for (var h = 0; h < arrLen; h++) {
            try4[h] = b[try2[h]]
          }
          // 打乱后的顺序
          this.wordListAll = try4
          // 答题modal为true
          this.challengeThree = false
          // 其他为false
          this.startChallenge = true
          this.startLearn = false
          this.startLearnOne = false
          this.start = false
          this.q = this.percent - 1
          this.parameter = []
          this.deleceParameter = []
          // 词语拼写
          if (this.wordListAll[this.q].flag === '0') {
            this.challengeSpell(this.q)
          }
          // 英译汉
          if (this.wordListAll[this.q].flag === '1') {
            this.challengeEnToCh(this.q)
          }
          // 汉译英
          if (this.wordListAll[this.q].flag === '2') {
            this.challengeChToEn(this.q)
          }
        })
      }
      setTimeout(() => {
        this.isDisable = false
      }, 300)
    },
    // 挑战题型
    challengeSpell (q) {
      // 拼写题型
      this.spell = true
      // 英译汉题型
      this.EnToCh = false
      // 汉译英题型
      this.ChToEn = false
      // 清空实时显示拼写区域内容
      this.answers = ''
      this.answersList = []
      this.c = q
      // 根据/拆分正确项
      var a = this.wordListAll[this.c].data.splitCorrect.split('/')
      // 根据/拆分干扰项
      var d = this.wordListAll[this.c].data.splitInterfere.split('/')
      // 都放到新数组里
      var b = []
      for (var i = 0; i < a.length; i++) {
        b.push(a[i])
      }
      for (var w = 0; w < d.length; w++) {
        b.push(d[w])
      }
      var arrLen = b.length
      // 创建数组 存放下标数
      var try1 = []
      for (var f = 0; f < arrLen; f++) {
        try1[f] = f
      }
      // 创建数组 生成随机下标数
      var try2 = []
      for (var g = 0; g < arrLen; g++) {
        try2[g] = try1.splice(Math.floor(Math.random() * try1.length), 1)
      }
      // 创建数组，生成对应随机下标数的数组
      var try3 = [{}, {}]
      for (var h = 0; h < arrLen; h++) {
        try3[h] = { id: h, data: b[try2[h]], flag: false }
      }
      // 存到选项按钮里
      this.option = try3
    },

    challengeEnToCh (q) {
      // 拼写题型
      this.spell = false
      // 英译汉题型
      this.EnToCh = true
      // 汉译英题型
      this.ChToEn = false
      this.c = q
      // 根据/拆分正确项
      var a = this.wordListAll[this.c].data.mainMeaning
      // console.log('aaaa --' + a)
      // 根据/拆分干扰项
      var d = this.wordListAll[this.c].data.meaningWrong.split('/')
      // console.log(' dddd --' + d)
      // 都放到新数组里
      var b = []
      b.push(a)
      for (var w = 0; w < d.length; w++) {
        b.push(d[w])
      }
      var arrLen = b.length
      // 创建数组 存放下标数
      var try1 = []
      for (var f = 0; f < arrLen; f++) {
        try1[f] = f
      }
      // 创建数组 生成随机下标数
      var try2 = []
      for (var g = 0; g < arrLen; g++) {
        try2[g] = try1.splice(Math.floor(Math.random() * try1.length), 1)
      }
      // 创建数组，生成对应随机下标数的数组
      var try3 = [{}, {}]
      for (var h = 0; h < arrLen; h++) {
        try3[h] = { id: h, data: b[try2[h]], flag: '' }
      }
      // console.log(' this.try3 --' + JSON.stringify(try3))
      // 存到选项按钮里
      this.optionEnToCh = try3
    },
    challengeChToEn (q) {
      this.c = q
      // 英译汉题型
      this.EnToCh = false
      // 拼写题型
      this.spell = false
      // 汉译英题型
      this.ChToEn = true

      // 根据/拆分正确项
      var a = this.wordListAll[this.c].data.word
      // 根据/拆分干扰项
      var d = this.wordListAll[this.c].data.wordWrong.split('/')
      // 都放到新数组里
      var b = []
      b.push(a)
      for (var w = 0; w < d.length; w++) {
        b.push(d[w])
      }
      var arrLen = b.length
      // 创建数组 存放下标数
      var try1 = []
      for (var f = 0; f < arrLen; f++) {
        try1[f] = f
      }
      // 创建数组 生成随机下标数
      var try2 = []
      for (var g = 0; g < arrLen; g++) {
        try2[g] = try1.splice(Math.floor(Math.random() * try1.length), 1)
      }
      // 创建数组，生成对应随机下标数的数组
      var try3 = [{}, {}]
      for (var h = 0; h < arrLen; h++) {
        try3[h] = { id: h, data: b[try2[h]], flag: '' }
      }
      // 存到选项按钮里
      this.optionChToEn = try3
    },
    // 判断拼写正确与否
    challengeJudgeSpell (answers) {
      this.isDisable = true
      this.c = this.percent - 1
      if (answers === this.wordListAll[this.c].data.word) {
        // 正确符号
        this.answersCurrect = true
        // 错误符号
        this.answersWrong = false
        this.homeworkParameter[this.c] = { homeworkId: this.homeworkId, questionId: this.wordListAll[this.c].data.id, score: 1, contentSource: answers, questionType: 0 }
        this.parameter[this.c] = { id: this.scoreId, unitId: this.unitId, score: 1, word: this.wordListAll[this.c].data.word, wordId: this.wordListAll[this.c].data.id }
        this.deleceParameter[this.c] = { id: this.wordListAll[this.c].data.wrongId, score: 1, word: this.wordListAll[this.c].data.word, wordId: this.wordListAll[this.c].data.wordId }
      } else {
        this.homeworkParameter[this.c] = { homeworkId: this.homeworkId, questionId: this.wordListAll[this.c].data.id, score: 0, contentSource: answers, questionType: 0 }
        this.parameter[this.c] = { id: this.scoreId, unitId: this.unitId, score: 0, word: this.wordListAll[this.c].data.word, wordId: this.wordListAll[this.c].data.id }
        this.deleceParameter[this.c] = { id: this.wordListAll[this.c].data.wrongId, score: 0, word: this.wordListAll[this.c].data.word, wordId: this.wordListAll[this.c].data.wordId }
        // 显示标记
        this.answersWrong = true
        this.parameterWrongWord = []
        this.parameterWrongWord = { wordId: this.wordListAll[this.c].data.id, studentId: this.studentId }
        addWrongWords(Object.assign(this.parameterWrongWord)).then(res => {
          this.WrongResultData = res.result
          if (this.WrongResultData === true) {
            // this.$message.success('已为您加入错词本!')
          } else {
            // this.$message.error('错词已存在')
          }
        }).catch(() => {
          this.$message.error('服务器错误')
        })
      }
      if (this.percent === this.total) {
        if (this.flashType === '0') {
          addObj(Object.assign(this.parameter)).then(res => {
            this.resultData = res.result
            this.startLearn = false
            this.start = false
            this.challengeThree = false
            this.startLearnOne = false
            // 开始挑战
            this.startChallenge = false
            // 清空实时显示答案区域
            this.answers = ''
            this.answersList = []
            this.endOption = ''
            // 隐藏词义
            this.show = false
            // 拼写题型
            this.spell = false
            // 英译汉题型
            this.EnToCh = false
            // 汉译英题型
            this.ChToEn = false
            // 正确符号
            this.answersCurrect = false
            // 错误符号
            this.answersWrong = false
            this.$message.success('完成挑战!')
            // 结果页
            this.resultView = true
          }).catch(() => {
            this.$message.error('服务器错误')
            this.vable = false
            this.bookId = this.bookId
            if (this.flashType === '1') {
              this.$emit('watchChild')
            } else {
              this.$emit('watchChild', this.bookId)
            }
          })
        }
        if (this.flashType === '1') {
          const that = this
          addHomework(Object.assign(this.homeworkParameter)).then(res => {
            this.resultData = res.result
            this.startLearn = false
            this.start = false
            this.challengeThree = false
            this.startLearnOne = false
            // 开始挑战
            this.startChallenge = false
            // 清空实时显示答案区域
            this.answers = ''
            this.answersList = []
            this.endOption = ''
            // 隐藏词义
            this.show = false
            // 拼写题型
            this.spell = false
            // 英译汉题型
            this.EnToCh = false
            // 汉译英题型
            this.ChToEn = false
            // 正确符号
            this.answersCurrect = false
            // 错误符号
            this.answersWrong = false
            // 结果页
            // this.resultView = true
            // this.$confirm({
            //   title: '恭喜您已完成此次作业',
            //   okText: '确定',
            //   okButtonProps: {
            //     on: {
            //       click: this.handleCancel
            //     }
            //   },
            //   cancelButtonProps: {
            //     on: {
            //       click: this.handleCancel
            //     }
            //   }
            // })
            if (res.result) {
              this.$success({
                title: '作业已提交！',
                onOk () {
                  that.vable = false
                  if (that.flashType === '1') {
                    that.$emit('watchChild')
                  } else {
                    that.$emit('watchChild', that.bookId)
                  }
                }
              })
            }
          }).catch(() => {
            this.$message.error('服务器错误')
            this.vable = false
            this.bookId = this.bookId
            if (this.flashType === '1') {
              this.$emit('watchChild')
            } else {
              this.$emit('watchChild', this.bookId)
            }
          })
        }
        if (this.flashType === '2') {
          deleteWrongWords(Object.assign(this.deleceParameter)).then(res => {
            this.resultData = res.result
            this.startLearn = false
            this.start = false
            this.challengeThree = false
            this.startLearnOne = false
            // 开始挑战
            this.startChallenge = false
            // 清空实时显示答案区域
            this.answers = ''
            this.answersList = []
            this.endOption = ''
            // 隐藏词义
            this.show = false
            // 拼写题型
            this.spell = false
            // 英译汉题型
            this.EnToCh = false
            // 汉译英题型
            this.ChToEn = false
            // 正确符号
            this.answersCurrect = false
            // 错误符号
            this.answersWrong = false
            this.$message.success('完成本页复习!')
            // 结果页
            this.resultView = true
          }).catch(() => {
            this.$message.error('服务器错误')
            this.vable = false
            this.bookId = this.bookId
            if (this.flashType === '1') {
              this.$emit('watchChild')
            } else {
              this.$emit('watchChild', this.bookId)
            }
          })
        }
      } else {
        setTimeout(() => {
          // 隐藏词义
          this.show = false
          // 错误符号
          this.answersWrong = false
          // 正确符号
          this.answersCurrect = false
          this.audio.playing = false
          let percent = this.percent + 1
          let percents = (100 / this.total) + this.percents
          if (percent > this.total && percents > 100) {
            percent = this.total
            percents = 100
          }
          this.percent = percent
          this.percents = percents
          this.q = this.percent - 1
          // 词语拼写
          if (this.wordListAll[this.q].flag === '0') {
            this.challengeSpell(this.q)
          }
          // 英译汉
          if (this.wordListAll[this.q].flag === '1') {
            this.challengeEnToCh(this.q)
          }
          // 汉译英
          if (this.wordListAll[this.q].flag === '2') {
            this.challengeChToEn(this.q)
          }
        }, 500)
      }
      setTimeout(() => {
        this.isDisable = false
      }, 500)
    },
    // 判断英译汉是否正确
    challengeJudgeEnToCh (itemEnToCh) {
      this.isDisable = true
      this.c = this.percent - 1
      if (itemEnToCh.data === this.wordListAll[this.c].data.mainMeaning) {
        this.optionEnToCh.forEach((item, i) => {
          if (itemEnToCh.id === item.id) {
            item.flag = true
          }
        })
        this.homeworkParameter[this.c] = { homeworkId: this.homeworkId, questionId: this.wordListAll[this.c].data.id, score: 1, contentSource: itemEnToCh.data, questionType: 1 }
        this.deleceParameter[this.c] = { id: this.wordListAll[this.c].data.wrongId, score: 1, word: this.wordListAll[this.c].data.word, wordId: this.wordListAll[this.c].data.wordId }
        this.parameter[this.c] = { id: this.scoreId, unitId: this.unitId, score: 1, word: this.wordListAll[this.c].data.word, wordId: this.wordListAll[this.c].data.id }
      } else {
        this.homeworkParameter[this.c] = { homeworkId: this.homeworkId, questionId: this.wordListAll[this.c].data.id, score: 0, contentSource: itemEnToCh.data, questionType: 1 }
        this.deleceParameter[this.c] = { id: this.wordListAll[this.c].data.wrongId, score: 0, word: this.wordListAll[this.c].data.word, wordId: this.wordListAll[this.c].data.wordId }
        this.parameter[this.c] = { id: this.scoreId, unitId: this.unitId, score: 0, word: this.wordListAll[this.c].data.word, wordId: this.wordListAll[this.c].data.id }
        this.parameterWrongWord = []
        this.parameterWrongWord = { wordId: this.wordListAll[this.c].data.id, studentId: this.studentId }
        addWrongWords(Object.assign(this.parameterWrongWord)).then(res => {
          this.WrongResultData = res.result
          if (this.WrongResultData === true) {
            // this.$message.success('已为您加入错词本!')
          } else {
            // this.$message.error('错词已存在')
          }
        }).catch(() => {
          this.$message.error('服务器错误')
        })
        this.optionEnToCh.forEach((item, i) => {
          if (itemEnToCh.id === item.id) {
            item.flag = false
          }
          // if (this.wordListAll[this.c].data.mainMeaning === item.data) {
          //   item.flag = true
          // }
        })
      }
      if (this.percent === this.total) {
        if (this.flashType === '0') {
          addObj(Object.assign(this.parameter)).then(res => {
            this.resultData = res.result
            this.startLearn = false
            this.start = false
            this.challengeThree = false
            this.startLearnOne = false
            // 开始挑战
            this.startChallenge = false
            // 清空实时显示答案区域
            this.answers = ''
            this.answersList = []
            this.endOption = ''
            // 隐藏词义
            this.show = false
            // 拼写题型
            this.spell = false
            // 英译汉题型
            this.EnToCh = false
            // 汉译英题型
            this.ChToEn = false
            // 正确符号
            this.answersCurrect = false
            // 错误符号
            this.answersWrong = false
            this.$message.success('完成挑战!')
            // 结果页
            this.resultView = true
          }).catch(() => {
            this.$message.error('服务器错误')
            this.vable = false
            this.bookId = this.bookId
            if (this.flashType === '1') {
              this.$emit('watchChild')
            } else {
              this.$emit('watchChild', this.bookId)
            }
          })
        }
        if (this.flashType === '1') {
          const that = this
          addHomework(Object.assign(this.homeworkParameter)).then(res => {
            this.resultData = res.result
            this.startLearn = false
            this.start = false
            this.challengeThree = false
            this.startLearnOne = false
            // 开始挑战
            this.startChallenge = false
            // 清空实时显示答案区域
            this.answers = ''
            this.answersList = []
            this.endOption = ''
            // 隐藏词义
            this.show = false
            // 拼写题型
            this.spell = false
            // 英译汉题型
            this.EnToCh = false
            // 汉译英题型
            this.ChToEn = false
            // 正确符号
            this.answersCurrect = false
            // 错误符号
            this.answersWrong = false
            // 结果页
            // this.resultView = true

            // this.$confirm({
            //   title: '恭喜您已完成此次作业',
            //   okText: '确定',
            //   okButtonProps: {
            //     on: {
            //       click: this.handleCancel
            //     }
            //   },
            //   cancelButtonProps: {
            //     on: {
            //       click: this.handleCancel
            //     }
            //   }
            // })

            if (res.result) {
              this.$success({
                title: '作业已提交！',
                onOk () {
                  that.vable = false
                  if (that.flashType === '1') {
                    that.$emit('watchChild')
                  } else {
                    that.$emit('watchChild', that.bookId)
                  }
                }
              })
            }
          }).catch(() => {
            this.$message.error('服务器错误')
            this.vable = false
            this.bookId = this.bookId
            if (this.flashType === '1') {
              this.$emit('watchChild')
            } else {
              this.$emit('watchChild', this.bookId)
            }
          })
        }
        if (this.flashType === '2') {
          deleteWrongWords(Object.assign(this.deleceParameter)).then(res => {
            this.resultData = res.result
            this.startLearn = false
            this.start = false
            this.challengeThree = false
            this.startLearnOne = false
            // 开始挑战
            this.startChallenge = false
            // 清空实时显示答案区域
            this.answers = ''
            this.answersList = []
            this.endOption = ''
            // 隐藏词义
            this.show = false
            // 拼写题型
            this.spell = false
            // 英译汉题型
            this.EnToCh = false
            // 汉译英题型
            this.ChToEn = false
            // 正确符号
            this.answersCurrect = false
            // 错误符号
            this.answersWrong = false
            this.$message.success('完成本页复习!')
            // 结果页
            this.resultView = true
          }).catch(() => {
            this.$message.error('服务器错误')
            this.vable = false
            this.bookId = this.bookId
            if (this.flashType === '1') {
              this.$emit('watchChild')
            } else {
              this.$emit('watchChild', this.bookId)
            }
          })
        }
      } else {
        setTimeout(() => {
          // 隐藏词义
          this.show = false
          // 错误符号
          this.answersWrong = false
          // 正确符号
          this.answersCurrect = false
          this.audio.playing = false
          let percent = this.percent + 1
          let percents = (100 / this.total) + this.percents
          if (percent > this.total && percents > 100) {
            percent = this.total
            percents = 100
          }
          this.percent = percent
          this.percents = percents
          this.q = this.percent - 1
          // 词语拼写
          if (this.wordListAll[this.q].flag === '0') {
            this.challengeSpell(this.q)
          }
          // 英译汉
          if (this.wordListAll[this.q].flag === '1') {
            this.challengeEnToCh(this.q)
          }
          // 汉译英
          if (this.wordListAll[this.q].flag === '2') {
            this.challengeChToEn(this.q)
          }
          // // 根据/拆分正确项
          //   var a = this.wordListAll[this.c].data.mainMeaning
          //   // 根据/拆分干扰项
          //   var d = this.wordListAll[this.c].data.meaningWrong.split('/')
          //   // 都放到新数组里
          //   var b = []
          //   b.push(a)
          //   for (var w = 0; w < d.length; w++) {
          //     b.push(d[w])
          //   }
          //   var arrLen = b.length
          //   // 创建数组 存放下标数
          //   var try1 = []
          //   for (var f = 0; f < arrLen; f++) {
          //     try1[f] = f
          //   }
          //   // 创建数组 生成随机下标数
          //   var try2 = []
          //   for (var g = 0; g < arrLen; g++) {
          //     try2[g] = try1.splice(Math.floor(Math.random() * try1.length), 1)
          //   }
          //   // 创建数组，生成对应随机下标数的数组
          //   var try3 = [{}, {}]
          //   for (var h = 0; h < arrLen; h++) {
          //     try3[h] = { id: h, data: b[ try2[h] ], flag: '' }
          //   }
          //   // 存到选项按钮里
          //   this.optionEnToCh = try3
        }, 500)
      }
      setTimeout(() => {
        this.isDisable = false
      }, 500)
    },
    // 判断汉译英是否正确
    challengeJudgeChToEn (itemChToEn) {
      this.isDisable = true
      this.c = this.percent - 1
      if (itemChToEn.data === this.wordListAll[this.c].data.word) {
        this.optionChToEn.forEach((item, i) => {
          if (itemChToEn.id === item.id) {
            item.flag = true
          }
        })
        this.homeworkParameter[this.c] = { homeworkId: this.homeworkId, questionId: this.wordListAll[this.c].data.id, score: 1, contentSource: itemChToEn.data, questionType: 2 }
        this.deleceParameter[this.c] = { id: this.wordListAll[this.c].data.wrongId, score: 1, word: this.wordListAll[this.c].data.word, wordId: this.wordListAll[this.c].data.wordId }
        this.parameter[this.c] = { id: this.scoreId, unitId: this.unitId, score: 1, word: this.wordListAll[this.c].data.word, wordId: this.wordListAll[this.c].data.id }
      } else {
        this.homeworkParameter[this.c] = { homeworkId: this.homeworkId, questionId: this.wordListAll[this.c].data.id, score: 0, contentSource: itemChToEn.data, questionType: 2 }
        this.deleceParameter[this.c] = { id: this.wordListAll[this.c].data.wrongId, score: 0, word: this.wordListAll[this.c].data.word, wordId: this.wordListAll[this.c].data.wordId }
        this.parameter[this.c] = { id: this.scoreId, unitId: this.unitId, score: 0, word: this.wordListAll[this.c].data.word, wordId: this.wordListAll[this.c].data.id }
        this.parameterWrongWord = []
        this.parameterWrongWord = { wordId: this.wordListAll[this.c].data.id, studentId: this.studentId }
        addWrongWords(Object.assign(this.parameterWrongWord)).then(res => {
          this.WrongResultData = res.result
          if (this.WrongResultData === true) {
            // this.$message.success('已为您加入错词本!')
          } else {
            // this.$message.error('错词已存在')
          }
        }).catch(() => {
          this.$message.error('服务器错误')
        })
        this.optionChToEn.forEach((item, i) => {
          if (itemChToEn.id === item.id) {
            item.flag = false
          }
          // if (this.wordListAll[this.c].data.word === item.data) {
          //   item.flag = true
          // }
        })
      }
      if (this.percent === this.total) {
        if (this.flashType === '0') {
          addObj(Object.assign(this.parameter)).then(res => {
            this.resultData = res.result
            this.startLearn = false
            this.start = false
            this.challengeThree = false
            this.startLearnOne = false
            // 开始挑战
            this.startChallenge = false
            // 清空实时显示答案区域
            this.answers = ''
            this.answersList = []
            this.endOption = ''
            // 隐藏词义
            this.show = false
            // 拼写题型
            this.spell = false
            // 英译汉题型
            this.EnToCh = false
            // 汉译英题型
            this.ChToEn = false
            // 正确符号
            this.answersCurrect = false
            // 错误符号
            this.answersWrong = false
            this.$message.success('完成挑战!')
            // 结果页
            this.resultView = true
          }).catch(() => {
            this.$message.error('服务器错误')
            this.vable = false
            this.bookId = this.bookId
            if (this.flashType === '1') {
              this.$emit('watchChild')
            } else {
              this.$emit('watchChild', this.bookId)
            }
          })
        }
        if (this.flashType === '1') {
          const that = this
          addHomework(Object.assign(this.homeworkParameter)).then(res => {
            this.resultData = res.result
            this.startLearn = false
            this.start = false
            this.challengeThree = false
            this.startLearnOne = false
            // 开始挑战
            this.startChallenge = false
            // 清空实时显示答案区域
            this.answers = ''
            this.answersList = []
            this.endOption = ''
            // 隐藏词义
            this.show = false
            // 拼写题型
            this.spell = false
            // 英译汉题型
            this.EnToCh = false
            // 汉译英题型
            this.ChToEn = false
            // 正确符号
            this.answersCurrect = false
            // 错误符号
            this.answersWrong = false
            // 结果页
            // this.resultView = true
            // this.$confirm({
            //   title: '恭喜您已完成此次作业',
            //   okText: '确定',
            //   okButtonProps: {
            //     on: {
            //       click: this.handleCancel
            //     }
            //   },
            //   cancelButtonProps: {
            //     on: {
            //       click: this.handleCancel
            //     }
            //   }
            // })

            if (res.result) {
              this.$success({
                title: '作业已提交！',
                onOk () {
                  that.vable = false
                  if (that.flashType === '1') {
                    that.$emit('watchChild')
                  } else {
                    that.$emit('watchChild', that.bookId)
                  }
                }
              })
            }
          }).catch(() => {
            this.$message.error('服务器错误')
            this.vable = false
            this.bookId = this.bookId
            if (this.flashType === '1') {
              this.$emit('watchChild')
            } else {
              this.$emit('watchChild', this.bookId)
            }
          })
        }
        if (this.flashType === '2') {
          deleteWrongWords(Object.assign(this.deleceParameter)).then(res => {
            this.resultData = res.result
            this.startLearn = false
            this.start = false
            this.challengeThree = false
            this.startLearnOne = false
            // 开始挑战
            this.startChallenge = false
            // 清空实时显示答案区域
            this.answers = ''
            this.answersList = []
            this.endOption = ''
            // 隐藏词义
            this.show = false
            // 拼写题型
            this.spell = false
            // 英译汉题型
            this.EnToCh = false
            // 汉译英题型
            this.ChToEn = false
            // 正确符号
            this.answersCurrect = false
            // 错误符号
            this.answersWrong = false
            this.$message.success('完成本页复习!')
            // 结果页
            this.resultView = true
          }).catch(() => {
            this.$message.error('服务器错误')
            this.vable = false
            this.bookId = this.bookId
            if (this.flashType === '1') {
              this.$emit('watchChild')
            } else {
              this.$emit('watchChild', this.bookId)
            }
          })
        }
      } else {
        setTimeout(() => {
          // 隐藏词义
          this.show = false
          // 错误符号
          this.answersWrong = false
          // 正确符号
          this.answersCurrect = false
          this.audio.playing = false
          let percent = this.percent + 1
          let percents = (100 / this.total) + this.percents
          if (percent > this.total && percents > 100) {
            percent = this.total
            percents = 100
          }
          this.percent = percent
          this.percents = percents
          this.q = this.percent - 1
          // 词语拼写
          if (this.wordListAll[this.q].flag === '0') {
            this.challengeSpell(this.q)
          }
          // 英译汉
          if (this.wordListAll[this.q].flag === '1') {
            this.challengeEnToCh(this.q)
          }
          // 汉译英
          if (this.wordListAll[this.q].flag === '2') {
            this.challengeChToEn(this.q)
          }
          // this.parameter[this.c].id = this.scoreId
          // this.parameter[this.c].unitId = this.unitId
          // this.parameter[this.c].studentId = this.studentId
          // this.parameter[this.c].score = 0

          // // 英译汉题型
          // this.EnToCh = false
          // // 拼写题型
          // this.spell = false
          // // 汉译英题型
          // this.ChToEn = true

          // // 根据/拆分正确项
          // var a = this.wordListAll[this.c].data.word
          // console.log('aaaa --' + a)
          // // 根据/拆分干扰项
          // var d = this.wordListAll[this.c].data.wordWrong.split('/')
          // console.log(' dddd --' + d)
          // // 都放到新数组里
          // var b = []
          // b.push(a)
          // for (var w = 0; w < d.length; w++) {
          //   b.push(d[w])
          // }
          // var arrLen = b.length
          // // 创建数组 存放下标数
          // var try1 = []
          // for (var f = 0; f < arrLen; f++) {
          //   try1[f] = f
          // }
          // // 创建数组 生成随机下标数
          // var try2 = []
          // for (var g = 0; g < arrLen; g++) {
          //   try2[g] = try1.splice(Math.floor(Math.random() * try1.length), 1)
          // }
          // // 创建数组，生成对应随机下标数的数组
          // var try3 = [{}, {}]
          // for (var h = 0; h < arrLen; h++) {
          //   try3[h] = { id: h, data: b[ try2[h] ], flag: '' }
          // }
          // console.log(' this.try3 --' + JSON.stringify(try3))
          // // 存到选项按钮里
          // this.optionChToEn = try3
        }, 500)
      }
      setTimeout(() => {
        this.isDisable = false
      }, 500)
    },
    // 判断学习汉译英是否正确
    judgeChToEn (itemChToEn) {
      this.isDisable = true
      this.c = this.percent - 1
      if (itemChToEn.data === this.wordList[this.c].word) {
        this.optionChToEn.forEach((item, i) => {
          if (itemChToEn.id === item.id) {
            item.flag = true
          }
        })
        if (this.percent === this.total) {
          if (this.flashType === '0') {
            this.$confirm({
              title: '是否开始挑战这个单元?',
              centered: true,
              okText: '是',
              cancelText: '否',
              okButtonProps: {
                on: {
                  click: this.challengeAll
                }
              },
              cancelButtonProps: {
                on: {
                  click: this.onCancel
                }
              }

            })
          }
          if (this.flashType === '1') {
            this.$confirm({
              title: '是否开始完成此作业?',
              centered: true,
              okText: '是',
              cancelText: '否',
              okButtonProps: {
                on: {
                  click: this.challengeAll
                }
              },
              cancelButtonProps: {
                on: {
                  click: this.onCancel
                }
              }

            })
          }
          if (this.flashType === '2') {
            this.$confirm({
              title: '是否开始挑战本页错题?',
              centered: true,
              okText: '是',
              cancelText: '否',
              okButtonProps: {
                on: {
                  click: this.challengeAll
                }
              },
              cancelButtonProps: {
                on: {
                  click: this.onCancel
                }
              }

            })
          }
        } else {
          setTimeout(() => {
            // 英译汉题型
            this.EnToCh = false
            // 拼写题型
            this.spell = false
            // 汉译英题型
            this.ChToEn = false

            this.audio.playing = false
            let percent = this.percent + 1
            let percents = (100 / this.total) + this.percents
            if (percent > this.total && percents > 100) {
              percent = this.total
              percents = 100
            }
            this.percent = percent
            // this.queryParam.unitId = this.unitId
            // getWordList(this.queryParam).then(res => {
            //   this.wordList = res.result.data
            // })
            this.percents = percents
            // 学习三种题型
            this.challengeThree = false
            // 开始学习，单词一览
            this.startLearn = true
            // 不熟悉单词界面
            this.startLearnOne = false
            // 初始画面一览界面
            this.start = false
            // 开始挑战
            this.startChallenge = false
          }, 500)
        }
      } else {
        this.optionChToEn.forEach((item, i) => {
          if (itemChToEn.id === item.id) {
            item.flag = false
          }
          if (this.wordList[this.c].word === item.data) {
            item.flag = true
          }
        })
        setTimeout(() => {
          // 英译汉题型
          this.EnToCh = false
          // 拼写题型
          this.spell = false
          // 汉译英题型
          this.ChToEn = true

          // 根据/拆分正确项
          var a = this.wordList[this.c].word
          // console.log('aaaa --' + a)
          // 根据/拆分干扰项
          var d = this.wordList[this.c].wordWrong.split('/')
          // console.log(' dddd --' + d)
          // 都放到新数组里
          var b = []
          b.push(a)
          for (var w = 0; w < d.length; w++) {
            b.push(d[w])
          }
          var arrLen = b.length
          // 创建数组 存放下标数
          var try1 = []
          for (var f = 0; f < arrLen; f++) {
            try1[f] = f
          }
          // 创建数组 生成随机下标数
          var try2 = []
          for (var g = 0; g < arrLen; g++) {
            try2[g] = try1.splice(Math.floor(Math.random() * try1.length), 1)
          }
          // 创建数组，生成对应随机下标数的数组
          var try3 = [{}, {}]
          for (var h = 0; h < arrLen; h++) {
            try3[h] = { id: h, data: b[try2[h]], flag: '' }
          }
          // console.log(' this.try3 --' + JSON.stringify(try3))
          // 存到选项按钮里
          this.optionChToEn = try3
        }, 500)
      }
      setTimeout(() => {
        this.isDisable = false
      }, 500)
    },
    onCancel () {
      if (this.flashType === '0') {
        this.getAllWord()
        // 清空实时显示答案区域
        this.answers = ''
        this.answersList = []
        this.endOption = ''
        // 拼写题型
        this.spell = false
        // 英译汉题型
        this.EnToCh = false
        // 汉译英题型
        this.ChToEn = false
        // 正确符号
        this.answersCurrect = false
        // 错误符号
        this.answersWrong = false
        this.start = true
        this.percent = 1
        this.startLearn = false
        this.challengeThree = false
        // 开始挑战
        this.startChallenge = false
      }
      if (this.flashType === '2') {
        this.getWrongWords()
        // 清空实时显示答案区域
        this.answers = ''
        this.answersList = []
        this.endOption = ''
        // 拼写题型
        this.spell = false
        // 英译汉题型
        this.EnToCh = false
        // 汉译英题型
        this.ChToEn = false
        // 正确符号
        this.answersCurrect = false
        // 错误符号
        this.answersWrong = false
        this.start = true
        this.percent = 1
        this.startLearn = false
        this.challengeThree = false
        // 开始挑战
        this.startChallenge = false
      }
    },
    // 判断学习英译汉是否正确
    judgeEnToCh (itemEnToCh) {
      this.isDisable = true
      this.c = this.percent - 1
      if (itemEnToCh.data === this.wordList[this.c].mainMeaning) {
        // console.log(' itemEnToCh.flag --' + JSON.stringify(this.itemEnToCh))
        this.optionEnToCh.forEach((item, i) => {
          if (itemEnToCh.id === item.id) {
            item.flag = true
          }
        })
        setTimeout(() => {
          // 英译汉题型
          this.EnToCh = false
          // 拼写题型
          this.spell = false
          // 汉译英题型
          this.ChToEn = true

          // 根据/拆分正确项
          var a = this.wordList[this.c].word
          // console.log('aaaa --' + a)
          // 根据/拆分干扰项
          var d = this.wordList[this.c].wordWrong.split('/')
          // console.log(' dddd --' + d)
          // 都放到新数组里
          var b = []
          b.push(a)
          for (var w = 0; w < d.length; w++) {
            b.push(d[w])
          }
          var arrLen = b.length
          // 创建数组 存放下标数
          var try1 = []
          for (var f = 0; f < arrLen; f++) {
            try1[f] = f
          }
          // 创建数组 生成随机下标数
          var try2 = []
          for (var g = 0; g < arrLen; g++) {
            try2[g] = try1.splice(Math.floor(Math.random() * try1.length), 1)
          }
          // 创建数组，生成对应随机下标数的数组
          var try3 = [{}, {}]
          for (var h = 0; h < arrLen; h++) {
            try3[h] = { id: h, data: b[try2[h]], flag: '' }
          }
          // console.log(' this.try3 --' + JSON.stringify(try3))
          // 存到选项按钮里
          this.optionChToEn = try3
        }, 500)
      } else {
        this.optionEnToCh.forEach((item, i) => {
          if (itemEnToCh.id === item.id) {
            item.flag = false
          }
          if (this.wordList[this.c].mainMeaning === item.data) {
            item.flag = true
          }
        })

        setTimeout(() => {
          // 根据/拆分正确项
          var a = this.wordList[this.c].mainMeaning
          // console.log('aaaa --' + a)
          // 根据/拆分干扰项
          var d = this.wordList[this.c].meaningWrong.split('/')
          console.log(' dddd --' + d)
          // 都放到新数组里
          var b = []
          b.push(a)
          for (var w = 0; w < d.length; w++) {
            b.push(d[w])
          }
          var arrLen = b.length
          // 创建数组 存放下标数
          var try1 = []
          for (var f = 0; f < arrLen; f++) {
            try1[f] = f
          }
          // 创建数组 生成随机下标数
          var try2 = []
          for (var g = 0; g < arrLen; g++) {
            try2[g] = try1.splice(Math.floor(Math.random() * try1.length), 1)
          }
          // 创建数组，生成对应随机下标数的数组
          var try3 = [{}, {}]
          for (var h = 0; h < arrLen; h++) {
            try3[h] = { id: h, data: b[try2[h]], flag: '' }
          }
          // console.log(' this.try3 --' + JSON.stringify(try3))
          // 存到选项按钮里
          this.optionEnToCh = try3
        }, 500)
      }
      setTimeout(() => {
        this.isDisable = false
      }, 500)
    },
    // 判断学习拼写正确与否
    judgeSpell (answers) {
      this.isDisable = true
      this.c = this.percent - 1
      if (answers === this.wordList[this.c].word) {
        // 正确符号
        this.answersCurrect = true
        // 错误符号
        this.answersWrong = false
        setTimeout(() => {
          // 英译汉题型
          this.EnToCh = true
          // 拼写题型
          this.spell = false
          // 汉译英题型
          this.ChToEn = false
          // 正确符号
          this.answersCurrect = false
          // 答题modal为true
          this.challengeThree = true
          // 其他为false
          this.startLearn = false
          // 开始挑战
          this.startChallenge = false
          this.startLearnOne = false
          this.start = false
          this.c = this.percent - 1
          // 根据/拆分正确项
          var a = this.wordList[this.c].mainMeaning
          // console.log('aaaa --' + a)
          // 根据/拆分干扰项
          var d = this.wordList[this.c].meaningWrong.split('/')
          // console.log(' dddd --' + d)
          // 都放到新数组里
          var b = []
          b.push(a)
          for (var w = 0; w < d.length; w++) {
            b.push(d[w])
          }
          var arrLen = b.length
          // 创建数组 存放下标数
          var try1 = []
          for (var f = 0; f < arrLen; f++) {
            try1[f] = f
          }
          // 创建数组 生成随机下标数
          var try2 = []
          for (var g = 0; g < arrLen; g++) {
            try2[g] = try1.splice(Math.floor(Math.random() * try1.length), 1)
          }
          // 创建数组，生成对应随机下标数的数组
          var try3 = [{}, {}]
          for (var h = 0; h < arrLen; h++) {
            try3[h] = { id: h, data: b[try2[h]], flag: '' }
          }
          // console.log(' this.try3 --' + JSON.stringify(try3))
          // 存到选项按钮里
          this.optionEnToCh = try3
        }, 800)
      } else {
        // 显示标记
        this.answersWrong = true
        // 正确符号
        this.answersCurrect = false
        // 答题modal为true
        this.challengeThree = true
        // 其他为false
        this.startLearn = false
        // 开始挑战
        this.startChallenge = false
        this.startLearnOne = false
        this.start = false
        this.TipsMessages = true
        setTimeout(() => {
          this.TipsMessages = false
        }, 1500)
      }
      setTimeout(() => {
        this.isDisable = false
      }, 800)
    },
    // 删除实时显示区域所有
    delectAnswersAll () {
      // console.log(' this.endOption2 --' + this.endOption)
      // this.answers.splice(answers.length, 1)
      // this.answers = this.answers.substring(0, this.answers.lastIndexOf(this.endOption))
      this.answers = ''
      this.answersList = []
      // 按钮状态变为可增加
      // for (var v = 0; v < this.option.length; v++) {
      //   this.option[v][1] = 'false'
      // }
      this.option.forEach((item, i) => {
        item.flag = 'false'
      })
      // 关闭错误符号
      this.answersWrong = false
      // 关闭正确符号
      this.answersCurrect = false
    },
    // 开始学习一个单词，三道题
    challengeOne () {
      // 拼写题型
      this.spell = true
      // 英译汉题型
      this.EnToCh = false
      // 汉译英题型
      this.ChToEn = false
      // 清空实时显示拼写区域内容
      this.answers = ''
      this.answersList = []
      // console.log(' this.percents --' + this.percent)
      // console.log(' this.wordList --' + JSON.stringify(this.wordList[0]))
      this.c = this.percent - 1
      // 根据/拆分正确项
      var a = this.wordList[this.c].splitCorrect.split('/')
      // console.log('aaaa --' + a)
      // 根据/拆分干扰项
      var d = this.wordList[this.c].splitInterfere.split('/')
      // console.log(' dddd --' + d)
      // 都放到新数组里
      var b = []
      for (var i = 0; i < a.length; i++) {
        b.push(a[i])
      }
      for (var w = 0; w < d.length; w++) {
        b.push(d[w])
      }
      var arrLen = b.length
      // 创建数组 存放下标数
      var try1 = []
      for (var f = 0; f < arrLen; f++) {
        try1[f] = f
      }
      // 创建数组 生成随机下标数
      var try2 = []
      for (var g = 0; g < arrLen; g++) {
        try2[g] = try1.splice(Math.floor(Math.random() * try1.length), 1)
      }
      // 创建数组，生成对应随机下标数的数组
      var try3 = [{}, {}]
      for (var h = 0; h < arrLen; h++) {
        try3[h] = { id: h, data: b[try2[h]], flag: false }
      }
      // console.log(' this.try3 --' + try3)
      // 存到选项按钮里
      this.option = try3
      // 答题modal为true
      this.challengeThree = true
      // 其他为false
      this.startLearn = false
      // 开始挑战
      this.startChallenge = false
      this.startLearnOne = false
      this.start = false
    },
    // 点击删除当前按钮内容
    cleanAnswer (optionItem) {
      // this.answers = this.answers.substring(0, this.answers.lastIndexOf(optionItem[0]))
      // this.answers = this.answers.replace(optionItem[0], '')
      for (var k = 0; k < this.answersList.length; k++) {
        if (optionItem.id === this.answersList[k]) {
          // console.log('optionItem.id --' + optionItem.id)
          // console.log('this.answersList[k] --' + this.answersList[k])
          this.answersList.splice(k, 1)
        }
      }
      // console.log(' this.answersList --' + JSON.stringify(this.answersList))
      var bss = []
      for (var j = 0; j < this.answersList.length; j++) {
        bss[j] = this.option[this.answersList[j]].data
      }

      // console.log(' bss --' + JSON.stringify(bss))
      // 作答 区域字符串
      this.answers = bss.join('')
      // this.answers = this.answers.replace(optionItem.data, '')
      // this.option[index][1] = 'false'
      this.option.forEach((item, i) => {
        if (optionItem.id === item.id) {
          item.flag = 'false'
        }
      })
      // 关闭错误记号
      this.answersWrong = false
    },
    // 点击增加当前按钮内容显示到答案上面
    addAnswer (optionItem) {
      // 点击的字符串
      this.endOption = optionItem.data
      // 定义新字符串等于当前作答 字符
      // var b = this.answers
      // 加上点击的字符串
      // b = b + optionItem.data
      var bs = this.answersList
      // console.log(' this.answersList --' + JSON.stringify(this.answersList))
      bs.push(optionItem.id)
      // console.log('bs --' + JSON.stringify(bs))
      this.option.forEach((item, i) => {
        if (optionItem.id === item.id) {
          item.flag = 'true'
        }
      })
      this.answersList = bs
      // console.log(' this.answersList --' + JSON.stringify(this.answersList))
      // var a = this.answersList.forEach((item, i) => {
      //   if (optionItem.id === item.id) {
      //     bss.push()
      //   }
      // })
      var bss = []
      for (var j = 0; j < this.answersList.length; j++) {
        bss[j] = this.option[this.answersList[j]].data
      }

      // console.log(' bss --' + JSON.stringify(bss))
      // 作答 区域字符串
      this.answers = bss.join('')
      // console.log(' this.answers --' + this.answers)
      // 关闭错误记号
      this.answersWrong = false
    },
    // 点击隐藏词义
    hiddenMean () {
      this.show = false
    },
    // 点击显示词义
    showMean () {
      this.show = true
    },
    startPlayOrPause () {
      return this.audio.playing ? this.pausePlay() : this.startPlay()
    },
    startPlayOrPauseUSA () {
      return this.audioUSA.playing ? this.pausePlayUSA() : this.startPlayUSA()
    },
    // 开始播放
    startPlay () {
      this.$refs.audio.play()
    },
    // 暂停
    pausePlay () {
      this.$refs.audio.pause()
    },
    // 开始播放
    startPlayUSA () {
      this.$refs.audioUSA.play()
    },
    // 暂停
    pausePlayUSA () {
      this.$refs.audioUSA.pause()
    },
    // 当播放异常时
    onError (percent) {
      this.playFlag = false
      this.wordList[percent - 1].britishSound = false
    },
    // 当音频开始播放
    onPlay (res) {
      this.audio.playing = true
      // console.log('长度：' + res.target.duration)
      if (this.onlyOnePlaying) {
        return
      }
      const target = res.target
      const audios = document.getElementsByTagName('audio');
      [...audios].forEach((item) => {
        if (item !== target) {
          item.pause()
        }
      })
    },
    onPause () {
      this.audio.playing = false
    },
    // 当音频开始播放
    onPlayUSA (res) {
      this.audioUSA.playing = true
      // console.log('长度：' + res.target.duration)
      if (this.onlyOnePlaying) {
        return
      }
      const target = res.target
      const audios = document.getElementsByTagName('audioUSA');
      [...audios].forEach((item) => {
        if (item !== target) {
          item.pause()
        }
      })
    },
    onPauseUSA () {
      this.audioUSA.playing = false
    },
    // 当timeupdate事件大概每秒一次，用来更新音频流的当前播放时间
    onTimeupdate (res) {
      this.sliderTime = parseInt(res.target.currentTime)
    },
    next () {
      this.current++
    },
    prev () {
      this.current--
    },
    //   进度条增加
    increase () {
      // 练习
      if (this.flashType === '0') {
        this.audio.playing = false
        let percent = this.percent + 1
        let percents = (100 / this.total) + this.percents
        if (percent > this.total && percents > 100) {
          percent = this.total
          percents = 100
        }
        this.percent = percent
        // this.queryParam.unitId = this.unitId
        // getWordList(this.queryParam).then(res => {
        //   this.wordList = res.result.data
        // })
        this.percents = percents
      }
      // 作业
      if (this.flashType === '1') {
        this.audio.playing = false
        let percent = this.percent + 1
        let percents = (100 / this.total) + this.percents
        if (percent > this.total && percents > 100) {
          percent = this.total
          percents = 100
        }
        this.percent = percent
        // this.queryParam.unitId = this.unitId
        // getWordList(this.queryParam).then(res => {
        //   this.wordList = res.result.data
        // })
        this.percents = percents
      }
      // 错词
      if (this.flashType === '2') {
        this.audio.playing = false
        let percent = this.percent + 1
        let percents = (100 / this.total) + this.percents
        if (percent > this.total && percents > 100) {
          percent = this.total
          percents = 100
        }
        this.percent = percent
        this.percents = percents
      }
    },
    //   进度条减少
    decline () {
      // 练习
      if (this.flashType === '0') {
        this.audio.playing = false
        let percent = this.percent - 1
        let percents = this.percents - (100 / this.total)
        if (percent < 1 && percents < (100 / this.total)) {
          percent = 1
          percents = 100 / this.total
        }
        this.percent = percent
        // console.log(' this.percent-- ' + this.percent)
        this.percents = percents
        // console.log(' this.percents --' + this.percents)
      }
      // 作业
      if (this.flashType === '1') {
        this.audio.playing = false
        let percent = this.percent - 1
        let percents = this.percents - (100 / this.total)
        if (percent < 1 && percents < (100 / this.total)) {
          percent = 1
          percents = 100 / this.total
        }
        this.percent = percent
        this.percents = percents
      }
      // 错词
      if (this.flashType === '2') {
        this.audio.playing = false
        let percent = this.percent - 1
        let percents = this.percents - (100 / this.total)
        if (percent < 1 && percents < (100 / this.total)) {
          percent = 1
          percents = 100 / this.total
        }
        this.percent = percent
        this.percents = percents
      }
    },
    // 开始学习
    learn () {
      this.challengeThree = false
      this.startLearn = true
      // 单词详情页
      this.startLearnOne = false
      // 开始挑战
      this.startChallenge = false
      this.start = false
    },
    // 去单词详情页
    goLearnDetail () {
      this.challengeThree = false
      this.startLearnOne = true
      // 开始学习
      this.startLearn = false
      this.start = false
      // 开始挑战
      this.startChallenge = false
    },
    getWrongWords () {
      this.queryParamWrongWords.current = this.current
      getWrongWords(this.queryParamWrongWords).then(res => {
        this.wordList = res.result.data
        this.total = res.result.data.length
        this.percents = (100 / this.total)
        this.percent = 1
        this.spinning = false
      })
    },
    flashWrong (current, flashType) {
      this.spinning = true
      this.current = current
      this.flashType = flashType
      this.getWrongWords()
      this.vable = true
      this.startLearn = false
      this.start = true
      this.challengeThree = false
      this.startLearnOne = false
      // 开始挑战
      this.startChallenge = false
      // 清空实时显示答案区域
      this.answers = ''
      this.answersList = []
      this.endOption = ''
      // 结果画面
      this.resultView = false
      // 隐藏词义
      this.show = false
      // 拼写题型
      this.spell = false
      // 英译汉题型
      this.EnToCh = false
      // 汉译英题型
      this.ChToEn = false
      // 正确符号
      this.answersCurrect = false
      // 错误符号
      this.answersWrong = false
      // const studentId = this.studentId
      // localStorage.setItem('current', current)
      // localStorage.setItem('flashType', flashType)
      // localStorage.setItem('studentId', studentId)
    },
    flashSeehomework (homeworkName, examPaperId, flashType, id) {
      this.homeworkName = homeworkName
      this.unitId = examPaperId
      this.vable = true
      this.flashType = flashType
      this.examPaperIdTrue = id
      this.homeworkId = id
      this.getAllWord()
      this.startLearn = false
      this.start = true
      this.challengeThree = false
      this.startLearnOne = false
      // 开始挑战
      this.startChallenge = false
      // 清空实时显示答案区域
      this.answers = ''
      this.answersList = []
      this.endOption = ''
      // 结果画面
      this.resultView = false
      // 隐藏词义
      this.show = false
      // 拼写题型
      this.spell = false
      // 英译汉题型
      this.EnToCh = false
      // 汉译英题型
      this.ChToEn = false
      // 正确符号
      this.answersCurrect = false
      // 错误符号
      this.answersWrong = false
      // const unitId = examPaperId
      // const studentId = this.studentId
      // const examPaperIdTrue = id
      // localStorage.setItem('unitId', unitId)
      // localStorage.setItem('homeworkId', examPaperIdTrue)
      // localStorage.setItem('studentId', studentId)
      // localStorage.setItem('flashType', flashType)
    },
    flashSee (bookId, id, study, period, press, required, elective, grade, volume, name, scoreId, flashType) {
      this.spinning = true
      this.bookId = bookId
      this.unitId = id
      this.study = study
      this.period = period
      this.press = press
      this.required = required
      this.elective = elective
      this.grade = grade
      this.volume = volume
      this.name = name
      this.scoreId = scoreId
      this.flashType = flashType
      this.vable = true
      this.getAllWord()
      this.startLearn = false
      this.start = true
      this.challengeThree = false
      this.startLearnOne = false
      // 开始挑战
      this.startChallenge = false
      // 清空实时显示答案区域
      this.answers = ''
      this.answersList = []
      this.endOption = ''
      // 结果画面
      this.resultView = false
      // 隐藏词义
      this.show = false
      // 拼写题型
      this.spell = false
      // 英译汉题型
      this.EnToCh = false
      // 汉译英题型
      this.ChToEn = false
      // 正确符号
      this.answersCurrect = false
      // 错误符号
      this.answersWrong = false
    },
    // 获取所有单词
    getAllWord () {
      this.spinning = true
      // console.log('this.unitId' + JSON.stringify(this.unitId))
      this.queryParam.unitId = this.unitId
      getWordList(this.queryParam).then(res => {
        this.newWordList = res.result.data
        // console.log('this.newWordList' + JSON.stringify(this.newWordList))
        this.total = res.result.data.length
        // console.log('this.total' + JSON.stringify(this.total))
        this.percents = (100 / this.total)
        this.percent = 1
        var arrLen = this.newWordList.length
        var b = this.newWordList
        // 创建数组 存放下标数
        var try1 = []
        for (var f = 0; f < arrLen; f++) {
          try1[f] = f
        }
        // 创建数组 生成随机下标数
        var try2 = []
        for (var g = 0; g < arrLen; g++) {
          try2[g] = try1.splice(Math.floor(Math.random() * try1.length), 1)
        }
        // 创建数组，生成对应随机下标数的数组
        var try4 = []
        for (var h = 0; h < arrLen; h++) {
          try4[h] = b[try2[h]]
        }
        // 打乱后的顺序
        this.wordList = try4
        // console.log('111this.wordList1111111111' + JSON.stringify(this.wordList))
        this.spinning = false
      })
    },
    flashOk () {
      this.vable = false
    },
    handleCancel () {
      this.vable = false
      this.bookId = this.bookId
      this.flashType = this.flashType
      if (this.flashType === '1') {
        this.$emit('watchChild')
      } else {
        this.$emit('watchChild', this.bookId)
      }
    }
  }
}
</script>
<style>
.answer-analysis {
  background-color: #f5f5f5;
  margin-top: 20px;
  margin-bottom: 30px;
  padding: 15px;
  border-radius: 10px;
}
.editorciyusuji {
  background-image: url(/huise.png);
  border: 1px solid rgb(233, 233, 233);
  border-radius: 5px;
  height: 620px;
  margin: 40px 30px;
  background-color: white;
  overflow: auto;
  overflow-x: hidden !important;
}
.resultViewEditorciyusuji {
  border: 1px solid rgb(233, 233, 233);
  border-radius: 5px;
  height: 510px;
  margin: 18px 30px 70px 30px;
  background-color: white;
  overflow: auto;
  overflow-x: hidden !important;
}
.ciyusujiWordCss {
  background-color: #dbf3ff;
}
.ciyusujiWordCss2 {
  background-color: white;
}
.steps-content {
  background-image: url(/huise.png);
  margin-top: 20px;
  padding-top: 20px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 535px;
  text-align: center;
  padding: 80px 100px 0px 100px;
}

.steps-action {
  margin-top: 24px;
}
.ciyusujibukefuzhi {
  -moz-user-select: none; /* Firefox私有属性 */
  -webkit-user-select: none; /* WebKit内核私有属性 */
  -ms-user-select: none; /* IE私有属性(IE10及以后) */
  -khtml-user-select: none; /* KHTML内核私有属性 */
  -o-user-select: none; /* Opera私有属性 */
  user-select: none; /* CSS3属性 */
}
.resultViewEditorciyusuji::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 6px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 4px;
}
.resultViewEditorciyusuji::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 5px;
  box-shadow: inset 0 0 5px #1e90fd;
  -webkit-box-shadow: inset 0 0 5px #1e90fd;
  background: rgba(0, 0, 0, 0.2);
}
.resultViewEditorciyusuji::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}
.imageflash {
  background-image: url(/resultView.png);
}
</style>
